import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaysService {
  public countries_en = [
    {'name': 'Afghanistan', 'code': 'AF'},
    {'name': 'land Islands', 'code': 'AX'},
    {'name': 'Albania', 'code': 'AL'},
    {'name': 'Algeria', 'code': 'DZ'},
    {'name': 'American Samoa', 'code': 'AS'},
    {'name': 'AndorrA', 'code': 'AD'},
    {'name': 'Angola', 'code': 'AO'},
    {'name': 'Anguilla', 'code': 'AI'},
    {'name': 'Antarctica', 'code': 'AQ'},
    {'name': 'Antigua and Barbuda', 'code': 'AG'},
    {'name': 'Argentina', 'code': 'AR'},
    {'name': 'Armenia', 'code': 'AM'},
    {'name': 'Aruba', 'code': 'AW'},
    {'name': 'Australia', 'code': 'AU'},
    {'name': 'Austria', 'code': 'AT'},
    {'name': 'Azerbaijan', 'code': 'AZ'},
    {'name': 'Bahamas', 'code': 'BS'},
    {'name': 'Bahrain', 'code': 'BH'},
    {'name': 'Bangladesh', 'code': 'BD'},
    {'name': 'Barbados', 'code': 'BB'},
    {'name': 'Belarus', 'code': 'BY'},
    {'name': 'Belgium', 'code': 'BE'},
    {'name': 'Belize', 'code': 'BZ'},
    {'name': 'Benin', 'code': 'BJ'},
    {'name': 'Bermuda', 'code': 'BM'},
    {'name': 'Bhutan', 'code': 'BT'},
    {'name': 'Bolivia', 'code': 'BO'},
    {'name': 'Bosnia and Herzegovina', 'code': 'BA'},
    {'name': 'Botswana', 'code': 'BW'},
    {'name': 'Bouvet Island', 'code': 'BV'},
    {'name': 'Brazil', 'code': 'BR'},
    {'name': 'British Indian Ocean Territory', 'code': 'IO'},
    {'name': 'Brunei Darussalam', 'code': 'BN'},
    {'name': 'Bulgaria', 'code': 'BG'},
    {'name': 'Burkina Faso', 'code': 'BF'},
    {'name': 'Burundi', 'code': 'BI'},
    {'name': 'Cambodia', 'code': 'KH'},
    {'name': 'Cameroon', 'code': 'CM'},
    {'name': 'Canada', 'code': 'CA'},
    {'name': 'Cape Verde', 'code': 'CV'},
    {'name': 'Cayman Islands', 'code': 'KY'},
    {'name': 'Central African Republic', 'code': 'CF'},
    {'name': 'Chad', 'code': 'TD'},
    {'name': 'Chile', 'code': 'CL'},
    {'name': 'China', 'code': 'CN'},
    {'name': 'Christmas Island', 'code': 'CX'},
    {'name': 'Cocos (Keeling) Islands', 'code': 'CC'},
    {'name': 'Colombia', 'code': 'CO'},
    {'name': 'Comoros', 'code': 'KM'},
    {'name': 'Congo', 'code': 'CG'},
    {'name': 'Congo, The Democratic Republic of the', 'code': 'CD'},
    {'name': 'Cook Islands', 'code': 'CK'},
    {'name': 'Costa Rica', 'code': 'CR'},
    {'name': 'Cote D\'Ivoire', 'code': 'CI'},
    {'name': 'Croatia', 'code': 'HR'},
    {'name': 'Cuba', 'code': 'CU'},
    {'name': 'Cyprus', 'code': 'CY'},
    {'name': 'Czech Republic', 'code': 'CZ'},
    {'name': 'Denmark', 'code': 'DK'},
    {'name': 'Djibouti', 'code': 'DJ'},
    {'name': 'Dominica', 'code': 'DM'},
    {'name': 'Dominican Republic', 'code': 'DO'},
    {'name': 'Ecuador', 'code': 'EC'},
    {'name': 'Egypt', 'code': 'EG'},
    {'name': 'El Salvador', 'code': 'SV'},
    {'name': 'Equatorial Guinea', 'code': 'GQ'},
    {'name': 'Eritrea', 'code': 'ER'},
    {'name': 'Estonia', 'code': 'EE'},
    {'name': 'Ethiopia', 'code': 'ET'},
    {'name': 'Falkland Islands (Malvinas)', 'code': 'FK'},
    {'name': 'Faroe Islands', 'code': 'FO'},
    {'name': 'Fiji', 'code': 'FJ'},
    {'name': 'Finland', 'code': 'FI'},
    {'name': 'France', 'code': 'FR'},
    {'name': 'French Guiana', 'code': 'GF'},
    {'name': 'French Polynesia', 'code': 'PF'},
    {'name': 'French Southern Territories', 'code': 'TF'},
    {'name': 'Gabon', 'code': 'GA'},
    {'name': 'Gambia', 'code': 'GM'},
    {'name': 'Georgia', 'code': 'GE'},
    {'name': 'Germany', 'code': 'DE'},
    {'name': 'Ghana', 'code': 'GH'},
    {'name': 'Gibraltar', 'code': 'GI'},
    {'name': 'Greece', 'code': 'GR'},
    {'name': 'Greenland', 'code': 'GL'},
    {'name': 'Grenada', 'code': 'GD'},
    {'name': 'Guadeloupe', 'code': 'GP'},
    {'name': 'Guam', 'code': 'GU'},
    {'name': 'Guatemala', 'code': 'GT'},
    {'name': 'Guernsey', 'code': 'GG'},
    {'name': 'Guinea', 'code': 'GN'},
    {'name': 'Guinea-Bissau', 'code': 'GW'},
    {'name': 'Guyana', 'code': 'GY'},
    {'name': 'Haiti', 'code': 'HT'},
    {'name': 'Heard Island and Mcdonald Islands', 'code': 'HM'},
    {'name': 'Holy See (Vatican City State)', 'code': 'VA'},
    {'name': 'Honduras', 'code': 'HN'},
    {'name': 'Hong Kong', 'code': 'HK'},
    {'name': 'Hungary', 'code': 'HU'},
    {'name': 'Iceland', 'code': 'IS'},
    {'name': 'India', 'code': 'IN'},
    {'name': 'Indonesia', 'code': 'ID'},
    {'name': 'Iran, Islamic Republic Of', 'code': 'IR'},
    {'name': 'Iraq', 'code': 'IQ'},
    {'name': 'Ireland', 'code': 'IE'},
    {'name': 'Isle of Man', 'code': 'IM'},
    {'name': 'Israel', 'code': 'IL'},
    {'name': 'Italy', 'code': 'IT'},
    {'name': 'Jamaica', 'code': 'JM'},
    {'name': 'Japan', 'code': 'JP'},
    {'name': 'Jersey', 'code': 'JE'},
    {'name': 'Jordan', 'code': 'JO'},
    {'name': 'Kazakhstan', 'code': 'KZ'},
    {'name': 'Kenya', 'code': 'KE'},
    {'name': 'Kiribati', 'code': 'KI'},
    {'name': 'Korea, Democratic People\'S Republic', 'code': 'KP'},
    {'name': 'Korea, Republic of', 'code': 'KR'},
    {'name': 'Kuwait', 'code': 'KW'},
    {'name': 'Kyrgyzstan', 'code': 'KG'},
    {'name': 'Lao People\'S Democratic Republic', 'code': 'LA'},
    {'name': 'Latvia', 'code': 'LV'},
    {'name': 'Lebanon', 'code': 'LB'},
    {'name': 'Lesotho', 'code': 'LS'},
    {'name': 'Liberia', 'code': 'LR'},
    {'name': 'Libyan Arab Jamahiriya', 'code': 'LY'},
    {'name': 'Liechtenstein', 'code': 'LI'},
    {'name': 'Lithuania', 'code': 'LT'},
    {'name': 'Luxembourg', 'code': 'LU'},
    {'name': 'Macao', 'code': 'MO'},
    {'name': 'Macedonia, The Former Yugoslav Republic of', 'code': 'MK'},
    {'name': 'Madagascar', 'code': 'MG'},
    {'name': 'Malawi', 'code': 'MW'},
    {'name': 'Malaysia', 'code': 'MY'},
    {'name': 'Maldives', 'code': 'MV'},
    {'name': 'Mali', 'code': 'ML'},
    {'name': 'Malta', 'code': 'MT'},
    {'name': 'Marshall Islands', 'code': 'MH'},
    {'name': 'Martinique', 'code': 'MQ'},
    {'name': 'Mauritania', 'code': 'MR'},
    {'name': 'Mauritius', 'code': 'MU'},
    {'name': 'Mayotte', 'code': 'YT'},
    {'name': 'Mexico', 'code': 'MX'},
    {'name': 'Micronesia, Federated States of', 'code': 'FM'},
    {'name': 'Moldova, Republic of', 'code': 'MD'},
    {'name': 'Monaco', 'code': 'MC'},
    {'name': 'Mongolia', 'code': 'MN'},
    {'name': 'Montenegro', 'code': 'ME'},
    {'name': 'Montserrat', 'code': 'MS'},
    {'name': 'Morocco', 'code': 'MA'},
    {'name': 'Mozambique', 'code': 'MZ'},
    {'name': 'Myanmar', 'code': 'MM'},
    {'name': 'Namibia', 'code': 'NA'},
    {'name': 'Nauru', 'code': 'NR'},
    {'name': 'Nepal', 'code': 'NP'},
    {'name': 'Netherlands', 'code': 'NL'},
    {'name': 'Netherlands Antilles', 'code': 'AN'},
    {'name': 'New Caledonia', 'code': 'NC'},
    {'name': 'New Zealand', 'code': 'NZ'},
    {'name': 'Nicaragua', 'code': 'NI'},
    {'name': 'Niger', 'code': 'NE'},
    {'name': 'Nigeria', 'code': 'NG'},
    {'name': 'Niue', 'code': 'NU'},
    {'name': 'Norfolk Island', 'code': 'NF'},
    {'name': 'Northern Mariana Islands', 'code': 'MP'},
    {'name': 'Norway', 'code': 'NO'},
    {'name': 'Oman', 'code': 'OM'},
    {'name': 'Pakistan', 'code': 'PK'},
    {'name': 'Palau', 'code': 'PW'},
    {'name': 'Palestinian Territory, Occupied', 'code': 'PS'},
    {'name': 'Panama', 'code': 'PA'},
    {'name': 'Papua New Guinea', 'code': 'PG'},
    {'name': 'Paraguay', 'code': 'PY'},
    {'name': 'Peru', 'code': 'PE'},
    {'name': 'Philippines', 'code': 'PH'},
    {'name': 'Pitcairn', 'code': 'PN'},
    {'name': 'Poland', 'code': 'PL'},
    {'name': 'Portugal', 'code': 'PT'},
    {'name': 'Puerto Rico', 'code': 'PR'},
    {'name': 'Qatar', 'code': 'QA'},
    {'name': 'Reunion', 'code': 'RE'},
    {'name': 'Romania', 'code': 'RO'},
    {'name': 'Russian Federation', 'code': 'RU'},
    {'name': 'RWANDA', 'code': 'RW'},
    {'name': 'Saint Helena', 'code': 'SH'},
    {'name': 'Saint Kitts and Nevis', 'code': 'KN'},
    {'name': 'Saint Lucia', 'code': 'LC'},
    {'name': 'Saint Pierre and Miquelon', 'code': 'PM'},
    {'name': 'Saint Vincent and the Grenadines', 'code': 'VC'},
    {'name': 'Samoa', 'code': 'WS'},
    {'name': 'San Marino', 'code': 'SM'},
    {'name': 'Sao Tome and Principe', 'code': 'ST'},
    {'name': 'Saudi Arabia', 'code': 'SA'},
    {'name': 'Senegal', 'code': 'SN'},
    {'name': 'Serbia', 'code': 'RS'},
    {'name': 'Seychelles', 'code': 'SC'},
    {'name': 'Sierra Leone', 'code': 'SL'},
    {'name': 'Singapore', 'code': 'SG'},
    {'name': 'Slovakia', 'code': 'SK'},
    {'name': 'Slovenia', 'code': 'SI'},
    {'name': 'Solomon Islands', 'code': 'SB'},
    {'name': 'Somalia', 'code': 'SO'},
    {'name': 'South Africa', 'code': 'ZA'},
    {'name': 'South Georgia and the South Sandwich Islands', 'code': 'GS'},
    {'name': 'Spain', 'code': 'ES'},
    {'name': 'Sri Lanka', 'code': 'LK'},
    {'name': 'Sudan', 'code': 'SD'},
    {'name': 'Suriname', 'code': 'SR'},
    {'name': 'Svalbard and Jan Mayen', 'code': 'SJ'},
    {'name': 'Swaziland', 'code': 'SZ'},
    {'name': 'Sweden', 'code': 'SE'},
    {'name': 'Switzerland', 'code': 'CH'},
    {'name': 'Syrian Arab Republic', 'code': 'SY'},
    {'name': 'Taiwan, Province of China', 'code': 'TW'},
    {'name': 'Tajikistan', 'code': 'TJ'},
    {'name': 'Tanzania, United Republic of', 'code': 'TZ'},
    {'name': 'Thailand', 'code': 'TH'},
    {'name': 'Timor-Leste', 'code': 'TL'},
    {'name': 'Togo', 'code': 'TG'},
    {'name': 'Tokelau', 'code': 'TK'},
    {'name': 'Tonga', 'code': 'TO'},
    {'name': 'Trinidad and Tobago', 'code': 'TT'},
    {'name': 'Tunisia', 'code': 'TN'},
    {'name': 'Turkey', 'code': 'TR'},
    {'name': 'Turkmenistan', 'code': 'TM'},
    {'name': 'Turks and Caicos Islands', 'code': 'TC'},
    {'name': 'Tuvalu', 'code': 'TV'},
    {'name': 'Uganda', 'code': 'UG'},
    {'name': 'Ukraine', 'code': 'UA'},
    {'name': 'United Arab Emirates', 'code': 'AE'},
    {'name': 'United Kingdom', 'code': 'GB'},
    {'name': 'United States', 'code': 'US'},
    {'name': 'United States Minor Outlying Islands', 'code': 'UM'},
    {'name': 'Uruguay', 'code': 'UY'},
    {'name': 'Uzbekistan', 'code': 'UZ'},
    {'name': 'Vanuatu', 'code': 'VU'},
    {'name': 'Venezuela', 'code': 'VE'},
    {'name': 'Viet Nam', 'code': 'VN'},
    {'name': 'Virgin Islands, British', 'code': 'VG'},
    {'name': 'Virgin Islands, U.S.', 'code': 'VI'},
    {'name': 'Wallis and Futuna', 'code': 'WF'},
    {'name': 'Western Sahara', 'code': 'EH'},
    {'name': 'Yemen', 'code': 'YE'},
    {'name': 'Zambia', 'code': 'ZM'},
    {'name': 'Zimbabwe', 'code': 'ZW'}
  ];

  public ville=[
    {
      name:"Douala"
    },{
      name:"Yaoundé"
    },{
      name:"Garoua"
    },{
      name:"Bamenda"
    },{
      name:"Maroua"
    },{
      name:"Nkongsamba"
    },{
      name:"Bafoussam"
    },{
      name:"Ngaoundéré"
    },{
      name:"Bertoua"
    },{
      name:"Loum"
    },{
      name:"Kumba"
    },{
      name:"Edéa"
    },{
      name:"Kumbo"
    },{
      name:"Foumban"
    },{
      name:"Mbouda"
    },{
      name:"Dschang"
    },{
      name:"Limbé"
    },{
      name:"Ebolowa"
    },{
      name:"Kousséri"
    },{
      name:"Guider"
    },{
      name:"Meiganga"
    },{
      name:"Yagoua"
    },{
      name:"Mbalmayo"
    },{
      name:"Bafang"
    },{
      name:"Tiko"
    },{
      name:"Bafia"
    },{
      name:"Wum"
    },{
      name:"Kribi"
    },{
      name:"Buea"
    },{
      name:"Sangmélima"
    },{
      name:"Foumbot"
    },{
      name:"Bangangté"
    },{
      name:"Batouri"
    },{
      name:"Banyo"
    },{
      name:"Nkambé"
    },{
      name:"Bali"
    },{
      name:"Mbanga"
    },{
      name:"Mokolo"
    },{
      name:"Melong"
    },{
      name:"Manjo"
    },{
      name:"Garoua-Boulaï"
    },{
      name:"Mora"
    },{
      name:"Kaélé"
    },{
      name:"Tibati"
    },{
      name:"Ndop"
    },{
      name:"Akonolinga"
    },{
      name:"Eséka"
    },{
      name:"Mamfé"
    },{
      name:"Obala"
    },{
      name:"Muyuka"
    },{
      name:"Nanga-Eboko"
    },{
      name:"Abong-Mbang"
    },{
      name:"Fundong"
    },{
      name:"Nkoteng"
    },{
      name:"Fontem"
    },{
      name:"Mbandjock"
    },{
      name:"Touboro"
    },{
      name:"Ngaoundal"
    },{
      name:"Yokadouma"
    },{
      name:"Pitoa"
    },{
      name:"Tombel"
    },{
      name:"Kékem"
    },{
      name:"Magba"
    },{
      name:"Bélabo"
    },{
      name:"Tonga"
    },{
      name:"Maga"
    },{
      name:"Koutaba"
    },{
      name:"Blangoua"
    },{
      name:"Guidiguis"
    },{
      name:"Bogo"
    },{
      name:"Batibo"
    },{
      name:"Yabassi"
    },{
      name:"Figuil"
    },{
      name:"Makénéné"
    },{
      name:"Gazawa"
    },{
      name:"Tcholliré"
    }
  ]

  public countries = [
    {
      'name': 'Afghanistan',
      'code': 'AF'
    },
    {
      'name': 'Afrique du Sud',
      'code': 'ZA'
    },
    {
      'name': 'Albanie',
      'code': 'AL'
    },
    {
      'name': 'Algérie',
      'code': 'DZ'
    },
    {
      'name': 'Allemagne',
      'code': 'DE'
    },
    {
      'name': 'Andorre',
      'code': 'AD'
    },
    {
      'name': 'Angola',
      'code': 'AO'
    },
    {
      'name': 'Anguilla',
      'code': 'AI'
    },
    {
      'name': 'Antarctique',
      'code': 'AQ'
    },
    {
      'name': 'Antigua-et-Barbuda',
      'code': 'AG'
    },
    {
      'name': 'Antilles néerlandaises',
      'code': 'AN'
    },
    {
      'name': 'Arabie saoudite',
      'code': 'SA'
    },
    {
      'name': 'Argentine',
      'code': 'AR'
    },
    {
      'name': 'Arménie',
      'code': 'AM'
    },
    {
      'name': 'Aruba',
      'code': 'AW'
    },
    {
      'name': 'Australie',
      'code': 'AU'
    },
    {
      'name': 'Autriche',
      'code': 'AT'
    },
    {
      'name': 'Azerbaïdjan',
      'code': 'AZ'
    },
    {
      'name': 'Bahamas',
      'code': 'BS'
    },
    {
      'name': 'Bahreïn',
      'code': 'BH'
    },
    {
      'name': 'Bangladesh',
      'code': 'BD'
    },
    {
      'name': 'Barbade',
      'code': 'BB'
    },
    {
      'name': 'Bélarus',
      'code': 'BY'
    },
    {
      'name': 'Belgique',
      'code': 'BE'
    },
    {
      'name': 'Belize',
      'code': 'BZ'
    },
    {
      'name': 'Bénin',
      'code': 'BJ'
    },
    {
      'name': 'Bermudes',
      'code': 'BM'
    },
    {
      'name': 'Bhoutan',
      'code': 'BT'
    },
    {
      'name': 'Bolivie',
      'code': 'BO'
    },
    {
      'name': 'Bosnie-Herzégovine',
      'code': 'BA'
    },
    {
      'name': 'Botswana',
      'code': 'BW'
    },
    {
      'name': 'Brésil',
      'code': 'BR'
    },
    {
      'name': 'Brunéi Darussalam',
      'code': 'BN'
    },
    {
      'name': 'Bulgarie',
      'code': 'BG'
    },
    {
      'name': 'Burkina Faso',
      'code': 'BF'
    },
    {
      'name': 'Burundi',
      'code': 'BI'
    },
    {
      'name': 'Cambodge',
      'code': 'KH'
    },
    {
      'name': 'Cameroun',
      'code': 'CM'
    },
    {
      'name': 'Canada',
      'code': 'CA'
    },
    {
      'name': 'Cap-Vert',
      'code': 'CV'
    },
    {
      'name': 'Ceuta et Melilla',
      'code': 'EA'
    },
    {
      'name': 'Chili',
      'code': 'CL'
    },
    {
      'name': 'Chine',
      'code': 'CN'
    },
    {
      'name': 'Chypre',
      'code': 'CY'
    },
    {
      'name': 'Colombie',
      'code': 'CO'
    },
    {
      'name': 'Comores',
      'code': 'KM'
    },
    {
      'name': 'Congo-Brazzaville',
      'code': 'CG'
    },
    {
      'name': 'Corée du Nord',
      'code': 'KP'
    },
    {
      'name': 'Corée du Sud',
      'code': 'KR'
    },
    {
      'name': 'Costa Rica',
      'code': 'CR'
    },
    {
      'name': 'Côte d’Ivoire',
      'code': 'CI'
    },
    {
      'name': 'Croatie',
      'code': 'HR'
    },
    {
      'name': 'Cuba',
      'code': 'CU'
    },
    {
      'name': 'Danemark',
      'code': 'DK'
    },
    {
      'name': 'Diego Garcia',
      'code': 'DG'
    },
    {
      'name': 'Djibouti',
      'code': 'DJ'
    },
    {
      'name': 'Dominique',
      'code': 'DM'
    },
    {
      'name': 'Égypte',
      'code': 'EG'
    },
    {
      'name': 'El Salvador',
      'code': 'SV'
    },
    {
      'name': 'Émirats arabes unis',
      'code': 'AE'
    },
    {
      'name': 'Équateur',
      'code': 'EC'
    },
    {
      'name': 'Érythrée',
      'code': 'ER'
    },
    {
      'name': 'Espagne',
      'code': 'ES'
    },
    {
      'name': 'Estonie',
      'code': 'EE'
    },
    {
      'name': 'État de la Cité du Vatican',
      'code': 'VA'
    },
    {
      'name': 'États fédérés de Micronésie',
      'code': 'FM'
    },
    {
      'name': 'États-Unis',
      'code': 'US'
    },
    {
      'name': 'Éthiopie',
      'code': 'ET'
    },
    {
      'name': 'Fidji',
      'code': 'FJ'
    },
    {
      'name': 'Finlande',
      'code': 'FI'
    },
    {
      'name': 'France',
      'code': 'FR'
    },
    {
      'name': 'Gabon',
      'code': 'GA'
    },
    {
      'name': 'Gambie',
      'code': 'GM'
    },
    {
      'name': 'Géorgie',
      'code': 'GE'
    },
    {
      'name': 'Géorgie du Sud et les îles Sandwich du Sud',
      'code': 'GS'
    },
    {
      'name': 'Ghana',
      'code': 'GH'
    },
    {
      'name': 'Gibraltar',
      'code': 'GI'
    },
    {
      'name': 'Grèce',
      'code': 'GR'
    },
    {
      'name': 'Grenade',
      'code': 'GD'
    },
    {
      'name': 'Groenland',
      'code': 'GL'
    },
    {
      'name': 'Guadeloupe',
      'code': 'GP'
    },
    {
      'name': 'Guam',
      'code': 'GU'
    },
    {
      'name': 'Guatemala',
      'code': 'GT'
    },
    {
      'name': 'Guernesey',
      'code': 'GG'
    },
    {
      'name': 'Guinée',
      'code': 'GN'
    },
    {
      'name': 'Guinée équatoriale',
      'code': 'GQ'
    },
    {
      'name': 'Guinée-Bissau',
      'code': 'GW'
    },
    {
      'name': 'Guyana',
      'code': 'GY'
    },
    {
      'name': 'Guyane française',
      'code': 'GF'
    },
    {
      'name': 'Haïti',
      'code': 'HT'
    },
    {
      'name': 'Honduras',
      'code': 'HN'
    },
    {
      'name': 'Hongrie',
      'code': 'HU'
    },
    {
      'name': 'Île Bouvet',
      'code': 'BV'
    },
    {
      'name': 'Île Christmas',
      'code': 'CX'
    },
    {
      'name': 'Île Clipperton',
      'code': 'CP'
    },
    {
      'name': 'Île de l\'Ascension',
      'code': 'AC'
    },
    {
      'name': 'Île de Man',
      'code': 'IM'
    },
    {
      'name': 'Île Norfolk',
      'code': 'NF'
    },
    {
      'name': 'Îles Åland',
      'code': 'AX'
    },
    {
      'name': 'Îles Caïmans',
      'code': 'KY'
    },
    {
      'name': 'Îles Canaries',
      'code': 'IC'
    },
    {
      'name': 'Îles Cocos - Keeling',
      'code': 'CC'
    },
    {
      'name': 'Îles Cook',
      'code': 'CK'
    },
    {
      'name': 'Îles Féroé',
      'code': 'FO'
    },
    {
      'name': 'Îles Heard et MacDonald',
      'code': 'HM'
    },
    {
      'name': 'Îles Malouines',
      'code': 'FK'
    },
    {
      'name': 'Îles Mariannes du Nord',
      'code': 'MP'
    },
    {
      'name': 'Îles Marshall',
      'code': 'MH'
    },
    {
      'name': 'Îles Mineures Éloignées des États-Unis',
      'code': 'UM'
    },
    {
      'name': 'Îles Salomon',
      'code': 'SB'
    },
    {
      'name': 'Îles Turks et Caïques',
      'code': 'TC'
    },
    {
      'name': 'Îles Vierges britanniques',
      'code': 'VG'
    },
    {
      'name': 'Îles Vierges des États-Unis',
      'code': 'VI'
    },
    {
      'name': 'Inde',
      'code': 'IN'
    },
    {
      'name': 'Indonésie',
      'code': 'ID'
    },
    {
      'name': 'Irak',
      'code': 'IQ'
    },
    {
      'name': 'Iran',
      'code': 'IR'
    },
    {
      'name': 'Irlande',
      'code': 'IE'
    },
    {
      'name': 'Islande',
      'code': 'IS'
    },
    {
      'name': 'Israël',
      'code': 'IL'
    },
    {
      'name': 'Italie',
      'code': 'IT'
    },
    {
      'name': 'Jamaïque',
      'code': 'JM'
    },
    {
      'name': 'Japon',
      'code': 'JP'
    },
    {
      'name': 'Jersey',
      'code': 'JE'
    },
    {
      'name': 'Jordanie',
      'code': 'JO'
    },
    {
      'name': 'Kazakhstan',
      'code': 'KZ'
    },
    {
      'name': 'Kenya',
      'code': 'KE'
    },
    {
      'name': 'Kirghizistan',
      'code': 'KG'
    },
    {
      'name': 'Kiribati',
      'code': 'KI'
    },
    {
      'name': 'Koweït',
      'code': 'KW'
    },
    {
      'name': 'Laos',
      'code': 'LA'
    },
    {
      'name': 'Lesotho',
      'code': 'LS'
    },
    {
      'name': 'Lettonie',
      'code': 'LV'
    },
    {
      'name': 'Liban',
      'code': 'LB'
    },
    {
      'name': 'Libéria',
      'code': 'LR'
    },
    {
      'name': 'Libye',
      'code': 'LY'
    },
    {
      'name': 'Liechtenstein',
      'code': 'LI'
    },
    {
      'name': 'Lituanie',
      'code': 'LT'
    },
    {
      'name': 'Luxembourg',
      'code': 'LU'
    },
    {
      'name': 'Macédoine',
      'code': 'MK'
    },
    {
      'name': 'Madagascar',
      'code': 'MG'
    },
    {
      'name': 'Malaisie',
      'code': 'MY'
    },
    {
      'name': 'Malawi',
      'code': 'MW'
    },
    {
      'name': 'Maldives',
      'code': 'MV'
    },
    {
      'name': 'Mali',
      'code': 'ML'
    },
    {
      'name': 'Malte',
      'code': 'MT'
    },
    {
      'name': 'Maroc',
      'code': 'MA'
    },
    {
      'name': 'Martinique',
      'code': 'MQ'
    },
    {
      'name': 'Maurice',
      'code': 'MU'
    },
    {
      'name': 'Mauritanie',
      'code': 'MR'
    },
    {
      'name': 'Mayotte',
      'code': 'YT'
    },
    {
      'name': 'Mexique',
      'code': 'MX'
    },
    {
      'name': 'Moldavie',
      'code': 'MD'
    },
    {
      'name': 'Monaco',
      'code': 'MC'
    },
    {
      'name': 'Mongolie',
      'code': 'MN'
    },
    {
      'name': 'Monténégro',
      'code': 'ME'
    },
    {
      'name': 'Montserrat',
      'code': 'MS'
    },
    {
      'name': 'Mozambique',
      'code': 'MZ'
    },
    {
      'name': 'Myanmar',
      'code': 'MM'
    },
    {
      'name': 'Namibie',
      'code': 'NA'
    },
    {
      'name': 'Nauru',
      'code': 'NR'
    },
    {
      'name': 'Népal',
      'code': 'NP'
    },
    {
      'name': 'Nicaragua',
      'code': 'NI'
    },
    {
      'name': 'Niger',
      'code': 'NE'
    },
    {
      'name': 'Nigéria',
      'code': 'NG'
    },
    {
      'name': 'Niue',
      'code': 'NU'
    },
    {
      'name': 'Norvège',
      'code': 'NO'
    },
    {
      'name': 'Nouvelle-Calédonie',
      'code': 'NC'
    },
    {
      'name': 'Nouvelle-Zélande',
      'code': 'NZ'
    },
    {
      'name': 'Oman',
      'code': 'OM'
    },
    {
      'name': 'Ouganda',
      'code': 'UG'
    },
    {
      'name': 'Ouzbékistan',
      'code': 'UZ'
    },
    {
      'name': 'Pakistan',
      'code': 'PK'
    },
    {
      'name': 'Palaos',
      'code': 'PW'
    },
    {
      'name': 'Panama',
      'code': 'PA'
    },
    {
      'name': 'Papouasie-Nouvelle-Guinée',
      'code': 'PG'
    },
    {
      'name': 'Paraguay',
      'code': 'PY'
    },
    {
      'name': 'Pays-Bas',
      'code': 'NL'
    },
    {
      'name': 'Pérou',
      'code': 'PE'
    },
    {
      'name': 'Philippines',
      'code': 'PH'
    },
    {
      'name': 'Pitcairn',
      'code': 'PN'
    },
    {
      'name': 'Pologne',
      'code': 'PL'
    },
    {
      'name': 'Polynésie française',
      'code': 'PF'
    },
    {
      'name': 'Porto Rico',
      'code': 'PR'
    },
    {
      'name': 'Portugal',
      'code': 'PT'
    },
    {
      'name': 'Qatar',
      'code': 'QA'
    },
    {
      'name': 'R.A.S. chinoise de Hong Kong',
      'code': 'HK'
    },
    {
      'name': 'R.A.S. chinoise de Macao',
      'code': 'MO'
    },
    {
      'name': 'régions éloignées de l’Océanie',
      'code': 'QO'
    },
    {
      'name': 'République centrafricaine',
      'code': 'CF'
    },
    {
      'name': 'République démocratique du Congo',
      'code': 'CD'
    },
    {
      'name': 'République dominicaine',
      'code': 'DO'
    },
    {
      'name': 'République tchèque',
      'code': 'CZ'
    },
    {
      'name': 'Réunion',
      'code': 'RE'
    },
    {
      'name': 'Roumanie',
      'code': 'RO'
    },
    {
      'name': 'Royaume-Uni',
      'code': 'GB'
    },
    {
      'name': 'Russie',
      'code': 'RU'
    },
    {
      'name': 'Rwanda',
      'code': 'RW'
    },
    {
      'name': 'Sahara occidental',
      'code': 'EH'
    },
    {
      'name': 'Saint-Barthélémy',
      'code': 'BL'
    },
    {
      'name': 'Saint-Kitts-et-Nevis',
      'code': 'KN'
    },
    {
      'name': 'Saint-Marin',
      'code': 'SM'
    },
    {
      'name': 'Saint-Martin',
      'code': 'MF'
    },
    {
      'name': 'Saint-Pierre-et-Miquelon',
      'code': 'PM'
    },
    {
      'name': 'Saint-Vincent-et-les Grenadines',
      'code': 'VC'
    },
    {
      'name': 'Sainte-Hélène',
      'code': 'SH'
    },
    {
      'name': 'Sainte-Lucie',
      'code': 'LC'
    },
    {
      'name': 'Samoa',
      'code': 'WS'
    },
    {
      'name': 'Samoa américaines',
      'code': 'AS'
    },
    {
      'name': 'Sao Tomé-et-Principe',
      'code': 'ST'
    },
    {
      'name': 'Sénégal',
      'code': 'SN'
    },
    {
      'name': 'Serbie',
      'code': 'RS'
    },
    {
      'name': 'Serbie-et-Monténégro',
      'code': 'CS'
    },
    {
      'name': 'Seychelles',
      'code': 'SC'
    },
    {
      'name': 'Sierra Leone',
      'code': 'SL'
    },
    {
      'name': 'Singapour',
      'code': 'SG'
    },
    {
      'name': 'Slovaquie',
      'code': 'SK'
    },
    {
      'name': 'Slovénie',
      'code': 'SI'
    },
    {
      'name': 'Somalie',
      'code': 'SO'
    },
    {
      'name': 'Soudan',
      'code': 'SD'
    },
    {
      'name': 'Sri Lanka',
      'code': 'LK'
    },
    {
      'name': 'Suède',
      'code': 'SE'
    },
    {
      'name': 'Suisse',
      'code': 'CH'
    },
    {
      'name': 'Suriname',
      'code': 'SR'
    },
    {
      'name': 'Svalbard et Île Jan Mayen',
      'code': 'SJ'
    },
    {
      'name': 'Swaziland',
      'code': 'SZ'
    },
    {
      'name': 'Syrie',
      'code': 'SY'
    },
    {
      'name': 'Tadjikistan',
      'code': 'TJ'
    },
    {
      'name': 'Taïwan',
      'code': 'TW'
    },
    {
      'name': 'Tanzanie',
      'code': 'TZ'
    },
    {
      'name': 'Tchad',
      'code': 'TD'
    },
    {
      'name': 'Terres australes françaises',
      'code': 'TF'
    },
    {
      'name': 'Territoire britannique de l\'océan Indien',
      'code': 'IO'
    },
    {
      'name': 'Territoire palestinien',
      'code': 'PS'
    },
    {
      'name': 'Thaïlande',
      'code': 'TH'
    },
    {
      'name': 'Timor oriental',
      'code': 'TL'
    },
    {
      'name': 'Togo',
      'code': 'TG'
    },
    {
      'name': 'Tokelau',
      'code': 'TK'
    },
    {
      'name': 'Tonga',
      'code': 'TO'
    },
    {
      'name': 'Trinité-et-Tobago',
      'code': 'TT'
    },
    {
      'name': 'Tristan da Cunha',
      'code': 'TA'
    },
    {
      'name': 'Tunisie',
      'code': 'TN'
    },
    {
      'name': 'Turkménistan',
      'code': 'TM'
    },
    {
      'name': 'Turquie',
      'code': 'TR'
    },
    {
      'name': 'Tuvalu',
      'code': 'TV'
    },
    {
      'name': 'Ukraine',
      'code': 'UA'
    },
    {
      'name': 'Union européenne',
      'code': 'EU'
    },
    {
      'name': 'Uruguay',
      'code': 'UY'
    },
    {
      'name': 'Vanuatu',
      'code': 'VU'
    },
    {
      'name': 'Venezuela',
      'code': 'VE'
    },
    {
      'name': 'Viêt Nam',
      'code': 'VN'
    },
    {
      'name': 'Wallis-et-Futuna',
      'code': 'WF'
    },
    {
      'name': 'Yémen',
      'code': 'YE'
    },
    {
      'name': 'Zambie',
      'code': 'ZM'
    },
    {
      'name': 'Zimbabwe',
      'code': 'ZW'
    }
  ];
// public villeFr =[
//   {
//     name:"Paris (75000)"
//   },
//   {
//     name:"Boulogne-Billancourt (92100)"
//   },
//   {
//     name:"Saint-Denis (93200)"
//   },
//   {
//     name:"Châtenay-Malabry (92290)"
//   },
//   {
//     name:"Montigny-le-Bretonneux (78180)"
//   },
//   {
//     name:"Palaiseau (91120)"
//   },
//   {
//     name:"Argenteuil (95100)"
//   },
//   {
//     name:"Athis-Mons (91200)"
//   },
//   {
//     name:"Montreuil (93100)"
//   },
//   {
//     name:"Villeneuve-Saint-Georges (94190)"
//   },
//   {
//     name:"Nanterre (92000)"
//   },
//   {
//     name:"Trappes (78190)"
//   },
//   {
//     name:"Vitry-sur-Seine (94400)"
//   },
//   {
//     name:"Les Mureaux (78130)"
//   },
//   {
//     name:"Créteil (94000)"
//   },
//   {
//     name:"Houilles (78800)"
//   },
//   {
//     name:"Asnières-sur-Seine (92600)"
//   },
//   {
//     name:"Plaisir (78370)"
//   },
//   {
//     name:"Versailles (78000)"
//   },
//   {
//     name:"Nogent-sur-Marne (94130)"
//   },
//   {
//     name:"Colombes (92700)"
//   },
//   {
//     name:"Chatou (78400)"
//   },
//   {
//     name:"Aubervilliers (93300)"
//   },
//   {
//     name:"Goussainville (95190)"
//   },
//   {
//     name:"Aulnay-sous-Bois (93600)"
//   },
//   {
//     name:"Viry-Châtillon (91170)"
//   },
//   {
//     name:"Courbevoie (92400)"
//   },
//   {
//     name:"L'Haÿ-les-Roses (94240)"
//   },
//   {
//     name:"Rueil-Malmaison (92500)"
//   },
//   {
//     name:"Vigneux-sur-Seine (91270)"
//   },
//   {
//     name:"Champigny-sur-Marne (94500)"
//   },
//   {
//     name:"Charenton-le-Pont (94220)"
//   },
//   {
//     name:"Saint-Maur-des-Fossés (94100)"
//   },
//   {
//     name:"Pontoise (95000)"
//   },
//   {
//     name:"Drancy (93700)"
//   },
//   {
//     name:"Cachan (94230)"
//   },
//   {
//     name:"Issy-les-Moulineaux (92130)"
//   },
//   {
//     name:"Savigny-le-Temple (77176)"
//   },
//   {
//     name:"Noisy-le-Grand (93160)"
//   },
//   {
//     name:"Clichy-sous-Bois (93390)"
//   },
//   {
//     name:"Levallois-Perret (92300)"
//   },
//   {
//     name:"Malakoff (92240)"
//   },
//   {
//     name:"Cergy (95000)"
//   },
//   {
//     name:"Villemomble (93250)"
//   },
//   {
//     name:"Antony (92160)"
//   },
//   {
//     name:"La Garenne-Colombes (92250)"
//   },
//   {
//     name:"Neuilly-sur-Seine (92200)"
//   },
//   {
//     name:"Pierrefitte-sur-Seine (93380)"
//   },
//   {
//     name:"Clichy (92110)"
//   },
//   {
//     name:"Saint-Cloud (92210)"
//   },
//   {
//     name:"Ivry-sur-Seine (94200)"
//   },
//   {
//     name:"Draveil (91210)"
//   },
//   {
//     name:"Sarcelles (95200)"
//   },
//   {
//     name:"Le Plessis-Robinson (92350)"
//   },
//   {
//     name:"Villejuif (94800)"
//   },
//   {
//     name:"Thiais (94320)"
//   },
//   {
//     name:"Le Blanc-Mesnil (93150)"
//   },
//   {
//     name:"Yerres (91330)"
//   },
//   {
//     name:"Pantin (93500)"
//   },
//   {
//     name:"Ermont (95120)"
//   },
//   {
//     name:"Pantin (93500)"
//   },
//   {
//     name:"Ermont (95120)"
//   },
//   {
//     name:"Maisons-Alfort (94700)"
//   },
//   {
//     name:"Bezons (95870)"
//   },
//   {
//     name:"Épinay-sur-Seine (93800)"
//   },
//   {
//     name:"Le Chesnay-Rocquencourt (78150)"
//   },
//   {
//     name:"Évry-Courcouronnes (91000)"
//   },
//   {
//     name:"Chelles (77500)"
//   },
//   {
//     name:"Villiers-sur-Marne (94350)"
//   },
//   {
//     name:"Meaux (77100)"
//   },
//   {
//     name:"Grigny (91350)"
//   },
//   {
//     name:"Fontenay-sous-Bois (94120)"
//   },
//   {
//     name:"Herblay-sur-Seine (95220)"
//   },
//   {
//     name:"Bondy (93140)"
//   },
//   {
//     name:"Bois-Colombes (92270)"
//   },
//   {
//     name:"Clamart (92140)"
//   },
//   {
//     name:"Vanves (92170)"
//   },
//   {
//     name:"Sartrouville (78500)"
//   },
//   {
//     name:"Guyancourt (78280)"
//   },
//   {
//     name:"Bobigny (93000)"
//   },
//   {
//     name:"Ris-Orangis (91130)"
//   },
//   {
//     name:"Sevran (93270)"
//   },
//   {
//     name:"Villiers-le-Bel (95400)"
//   },
//   {
//     name:"Corbeil-Essonnes (91100)"
//   },
//   {
//     name:"Fresnes (94260)"
//   },
//   {
//     name:"Vincennes (94300)"
//   },
//   {
//     name:"Sannois (95110)"
//   },
//   {
//     name:"Montrouge (92120)"
//   },
//   {
//     name:"Bussy-Saint-Georges (77600)"
//   },
//   {
//     name:"Suresnes (92150)"
//   },
//   {
//     name:"Sucy-en-Brie (94370)"
//   },
//   {
//     name:"Saint-Ouen-sur-Seine (93400)"
//   },
//   {
//     name:"Villeparisis (77270)"
//   },
//   {
//     name:"Massy (91300)"
//   },
//   {
//     name:"Brétigny-sur-Orge (91220)"
//   },
//   {
//     name:"Meudon (92190)"
//   },
//   {
//     name:"Gonesse (95500)"
//   },
//   {
//     name:"Puteaux (92800)"
//   },
//   {
//     name:"Brunoy (91800)"
//   },
//   {
//     name:"Mantes-la-Jolie (78200)"
//   },
//   {
//     name:"Taverny (95150)"
//   },
//   {
//     name:"Rosny-sous-Bois (93110)"
//   },
//   {
//     name:"Romainville (93230)"
//   },
//   {
//     name:"Gennevilliers (92230)"
//   },
//   {
//     name:"Montfermeil (93370)"
//   },
//   {
//     name:"Livry-Gargan (93190)"
//   },
//   {
//     name:"Le Kremlin-Bicêtre (94270)"
//   },
//   {
//     name:"Alfortville (94140)"
//   },
//   {
//     name:"Limeil-Brévannes (94450)"
//   },
//   {
//     name:"Choisy-le-Roi (94600)"
//   },
//   {
//     name:"Élancourt (78990)"
//   },
//   {
//     name:"Noisy-le-Sec (93130)"
//   },
//   {
//     name:"Rambouillet (78120)"
//   },
//   {
//     name:"Garges-lès-Gonesse (95140)"
//   },
//   {
//     name:"Champs-sur-Marne (77420)"
//   },
//   {
//     name:"La Courneuve (93120)"
//   },
//   {
//     name:"Les Ulis (91940)"
//   },
//   {
//     name:"Saint-Germain-en-Laye (78100)"
//   },
//   {
//     name:"Eaubonne (95600)"
//   },
//   {
//     name:"Melun (77000)"
//   },
//   {
//     name:"Saint-Ouen-l'Aumône (95310)"
//   },
//   {
//     name:"Gagny (93220)"
//   },
//   {
//     name:"Villeneuve-la-Garenne (92390)"
//   },
//   {
//     name:"Stains (93240)"
//   },
//   {
//     name:"Étampes (91150)"
//   },
//   {
//     name:"Bagneux (92220)"
//   },
//   {
//     name:"Fontenay-aux-Roses (92260)"
//   },
//   {
//     name:"Pontault-Combault (77340)"
//   },
//   {
//     name:"Montgeron (91230)"
//   },
//   {
//     name:"Châtillon (92320)"
//   },
//   {
//     name:"Cormeilles-en-Parisis (95240)"
//   },
//   {
//     name:"Poissy (78300)"
//   },
//   {
//     name:"Torcy (77200)"
//   },
//   {
//     name:"Villepinte (93420)"
//   },
//   {
//     name:"Maisons-Laffitte (78600)"
//   },
//   {
//     name:"Savigny-sur-Orge (91600)"
//   },
//   {
//     name:"Les Pavillons-sous-Bois (93320)"
//   },
//   {
//     name:"Bagnolet (93170)"
//   },
//   {
//     name:"Sèvres (92310)"
//   },
//   {
//     name:"Sainte-Geneviève-des-Bois (91700)"
//   },
//   {
//     name:"Orly (94310)"
//   },
//   {
//     name:"Roissy-en-Brie (77680)"
//   },
//   {
//     name:"Tremblay-en-France (93290)"
//   },
//   {
//     name:"Les Lilas (93260)"
//   },
//   {
//     name:"Conflans-Sainte-Honorine (78700)"
//   },
//   {
//     name:"Saint-Mandé (94160)"
//   },
//   {
//     name:"Combs-la-Ville (77380)"
//   },
//   {
//     name:"Franconville (95130)"
//   },
//   {
//     name:"Deuil-la-Barre (95170)"
//   },
//   {
//     name:"Neuilly-sur-Marne (93330)"
//   },
//   {
//     name:"Longjumeau (91160)"
//   },
//   {
//     name:"Le Perreux-sur-Marne (94170)"
//   },
  
// ]
public regionCm=[
  {name:'Adamaoua'},
  {name:'Centre'},
  {name:'Est'},
  {name:'Extrême-Nord'},
  {name:'Littoral'},
  {name:'Nord'},
  {name:'Nord-Ouest'},
  {name:'Sud'},
  {name:'Sud-Ouest'},
  {name:'Ouest'},
]
public regionFr=[
 {name:' Alsace'},
 {name:'Aquitaine'},
 {name:'Auvergne'},
 {name:'Basse-Normandie'},
 {name:'Bourgogne'},
 {name:'Bretagne'},
 {name:'Centre'},
 {name:'Champagne-Ardenne'},
 {name:'Corse'},
 {name:'Franche-Comté'},
 {name:'Haute-Normandie'},
 {name:'Île-de-France'},
 {name:'Languedoc-Roussillon'},
 {name:'Limousin'},
 {name:'Lorraine'},
 {name:'Midi-Pyrénées'},
 {name:'Nord-Pas-de-Calais'},
 {name:'Pays de la Loire'},
 {name:'Picardie'},
 {name:'Poitou-Charentes'},
 {name:"Provence-Alpes-Côte d'Azur"},
 {name:"Rhône-Alpes"}
]
public villeFr =[
  {
  name: 'Paris (75000) '
  },
  {name: "Paris 1er Arrondissement (75001) "},
  
  {name :" Paris 2e Arrondissement (75002) " },
  
  {name :'Paris 3e Arrondissement (75003) '},
  
  {name :'Paris 4e Arrondissement (75004) ' },
  
  { name :'Paris 5e Arrondissement (75005) '},
  

  
{name : ' Paris 6e Arrondissement (75006)  '},
  

  
{name: ' Paris 7e Arrondissement (75007) '},
  
  {name:'Paris 8e Arrondissement (75008) '},
  
  
  { name :'Paris 9e Arrondissement (75009) ' },
  
  {name :'Paris 10e Arrondissement (75010) ' },
  
  {name:'Paris 11e Arrondissement (75011)'},
  
   
  
  {name:'Paris 12e Arrondissement (75012)'},
  

 {name: 'Paris 13e Arrondissement (75013 )'},
   
  
  {name:'Paris 14e Arrondissement (75014)'},
   
  
  {name:'Paris 15e Arrondissement (75015)'}, 
  
  {name:'Paris 16e Arrondissement (75016)'}, 
   
  
  {name:'Paris 17e Arrondissement (75017)'},
   
  
  {name:'Paris 18e Arrondissement (75018)'},
  
  
  
  {name :'Paris 19e Arrondissement (75019 '},
  
  
  {name:'Paris 20e Arrondissement (75020 )'},
  
  
  {name :'Livry-sur-Seine (77000 )'},
  {name :"Melun (77000 )"},
  {name :"La Rochette (77000 )"},
  {name :'Vaux-le-Pénil (77000 )'},
  
  
  {name:'Collégien (77090 )'},
  
   
  
 {name:' Mareuil-lès-Meaux   (77100)'},
 {name:' Meaux (77100)'},
 {name:' Nanteuil-lès-Meaux (77100)'},
  
  
  {name:'Soignolles-en-Brie  (77111) '},
  {name:'Solers (77111) '},
  
  {name:'Gouaix  (77114) '},
  {name:'Hermé  (77114) '},
  {name:'Noyen-sur-Seine  (77114) '},
  {name:'Villiers-sur-Seine (77114) '},
  
  {name:'Blandy (77115)'},
  {name:'Sivry-Courtry (77115)'},
  
  
  {name:'Balloy'},
  {name:'Bazoches-lès-Bray'},
  {name:'Gravon '},
   
  
  {name :'Amillis (77120)'},
  {name :'Aulnoy (77120)'},
  {name :'Beautheil (77120)'},
  {name :'Chailly-en-Brie (77120)'},
  {name :'Coulommiers (77120)'},
  {name :'Giremoutiers(77120)'},
  {name :'Marolles-en-Brie  (77120)'},
  {name :'Mauperthuis (77120)'},
  {name :'Mouroux(77120)'},
  {name :'Saints (77120)'},


  
   
  
  {name:'Monthyon (77122)'},
  
  
  
  {name :'Noisy-sur-École (77123) '},
  {name :'Tousson (77123) '},
  {name :'Le Vaudoué (77123) '},
  
  {name:'Crégy-lès-Meaux (77124) '},
  {name:'Chauconin-Neufmontiers (77124) '},
  {name:'Penchard (77124) '},
  {name:'Villenoy (77124) '},
  
  {name:'Châtenay-sur-Seine (77126) '}, 
  {name:'Courcelles-en-Bassée (77126) '}, 
  {name:'Égligny (77126) '}, 
  
  {name:'Lieusaint (77127)'},
   
  {name:'Barbey (77130)'},
  {name:'Cannes-Écluse (77130)'},
  {name:'Dormelles Forges (77130)'},
  {name:'Forges (77130)'},
  {name:'La Grande-Paroisse (77130)'},
  {name:'Marolles-sur-Seine  (77130)'},
  {name:'Misy-sur-Yonne (77130)'},
  {name:'Montereau-Fault-Yonne (77130)'},
  {name:'Saint-Germain-Laval (77130)'},
  {name:'La Tombe  (77130)'},
  {name:'Varennes-sur-Seine(77130)'},
  {name:'Ville-Saint-Jacques (77130)'},

  
  {name:'Pézarches (77131) '},
  {name:'Touquin (77131) '},
  
  
  
  {name:'Féricy (77133) '},
  {name:'Machault (77133) '},
  
  
  {name:'Les Ormes-sur-Voulzie (77134) '},
  
  {name:'Pontcarré (77135) ' },
  
  {name:'Luzancy (77138) '},

  
  {name:'Douy-la-Ramée (77139) '},
  {name:'Étrépilly (77139) '},
  {name:' Marcilly (77139) '},
  {name:' Puisieux (77139) '},
  {name:'Vincy-Manoeuvre (77139) '},
  
  {name:'Darvault (77140) '},
  {name:'Montcourt-Fromonville (77140) '},
  {name:'Nemours  (77140) '},
  {name:'Nonville (77140) '},
  {name:'Saint-Pierre-lès-Nemours (77140) '},
  
  
  {name:' Vaudoy-en-Brie (77141) '},
  
  {name:'Chalifert  (77144) '},
  {name:' Montévrain (77144) '},
  
  {name:'May-en-Multien (77145) '}, 
  
  {name: 'Laval-en-Brie  (77148)'},
  {name: 'Salins (77148)'},
  
  {name: 'Férolles-Attilly (77150) '},
  {name: ' Lésigny (77150) '},
  
  {name:'Montceaux-lès-Provins (77151)'} ,
  
 { name:'Coutençon (77154)'},
 { name:' Villeneuve-les-Bordes (77154)'},
   
  {name:'Everly (77157)'},
   
  
  {name:'Chalautre-la-Petite (77160)' }, 
  {name:'La Chapelle-Saint-Sulpice (77160)' }, 
  {name:'Chenoise(77160)' }, 
  {name:' Cucharmoy (77160)' }, 
  {name:'Mortery (77160)' }, 
  {name:'Poigny (77160)' }, 
  {name:'Provins (77160)' }, 
  {name:'Rouilly  (77160)' }, 
  {name:'Saint-Brice (77160)' }, 
  {name:'Saint-Hilliers (77160)' }, 
  {name:'Vulaines-lès-Provins (77160)' }, 

  
  {name:'Dammartin-sur-Tigeaux Mortcerf  (77163)'},
  {name:'Tigeaux (77163)'},
  
  {name: 'Ferrières-en-Brie 77164'},
  
  {name:"Cuisy 77165" },
  {name:" Forfry 77165" },
  {name:"Gesvres-le-Chapitre 77165" },
  {name:"Iverny 77165" },
  {name:"Le Plessis-aux-Bois 77165" },
  {name:"Le Plessis-l'Évêque 77165" },
  {name:"Saint-Soupplets 77165" },
  
  {name:'Évry-Grégy-sur-Yerre '},
  {name:'Grisy-Suisnes 77166 '},
  
 {name:" Bagneaux-sur-Loing 77167 "},
 {name:" Châtenoy 77167 "},
 {name:" Faÿ-lès-Nemours 77167 "},
 {name:" Ormesson 77167 "},
 {name:" Poligny 77167 "},
  
  {name:"Boissy-le-Châtel 77169 "},
  {name:"Chauffry 77169 "},
  {name:" Saint-Germain-sous-Doue 77169 "},
  {name:" Saint-Siméon 77169 "},

 {name:' Brie-Comte-Robert 77170 '},
 {name:' Coubert Servon 77170 '},
  
  {name:'Chalautre-la-Grande 77171 '},
  {name:'Léchelle 77171 '},
  {name:'Melz-sur-Seine 77171 '},
  {name:'Sourdun 77171 '},
  
  {name:'Chevry-Cossigny 77173 '},
  
  {name:'Villeneuve-le-Comte 77174 '},
  {name:'Villeneuve-Saint-Denis 77174 '},

  
  
  {name:'Nandy 77176 '},
  {name:'Savigny-le-Temple 77176 '},
   
  
{name:'  Brou-sur-Chantereine 77177'}, 
  
  {name:'Oissery 77178'},
  {name:'Saint-Pathus 77178'},
   
  
  {name:'Courtry Le Pin 77181'},
   
  {name:'Croissy-Beaubourg 77183'},
  
  
  {name:'Émerainville 77184 '}, 
  
  {name:'Lognes 77185'},
  
  
  {name:'Noisiel 77186 '},
  
  
  {name:'Dammarie-les-Lys 77190 '}, 
  {name:'Villiers-en-Bière 77190 '}, 
  
  {name:'Torcy 77200'}, 
  
  {name:'Avon Samoreau 77210'},
  
  
  {name:'Favières 77220 '},
  {name:'Gretz-Armainvilliers 77220 '},
  {name:'Liverdy-en-Brie 77220 '},
  {name:' Presles-en-Brie 77220 '},
  {name:'Tournan-en-Brie 77220 '},
  
  {name:"Dammartin-en-Goële 77230"},
   {name:"Juilly 77230"},
  { name:"Longperrier 77230"},
   {name:"Marchémoret 77230"},
   {name:"Montgé-en-Goële 77230"},
   {name:"Moussy-le-Neuf 77230"},
   {name:"Moussy-le-Vieux 77230"},
   {name:"Nantouillet 77230"},
   {name:"Rouvres 77230"},
   {name:"Saint-Mard 77230"},
   {name:"Thieux 77230"},
   {name:"Villeneuve-sous-Dammartin 77230"},
   {name:'Vinantes 77230'},
  
  
  
   {name:'Cesson 77240 '},
   {name:'Seine-Port 77240' },
   {name:'Vert-Saint-Denis 77240 '},
   
  
   {name:"Écuelles 77250"},
   {name:"Épisy 77250"},
   {name:"Montarlot 77250"},
   {name:"Moret-sur-Loing 77250 "},
   {name:"Veneux-les-Sablons 77250"},
   {name:"Villecerf 77250"},
   {name:"Villemer 77250"}, 
  
   {name:'Chamigny 77260'},
   {name:'La Ferté-sous-Jouarre 77260'},
   {name:'Reuil-en-Brie 77260'},
   {name:'Sainte-Aulde 77260'},
   {name:'Sammeron 77260'},
   {name:'Sept-Sorts 77260'},
   {name:'Ussy-sur-Marne 77260'}, 
  
  {name:'Villeparisis 77270'}, 
  
  {name :'Othis 77280'}, 
  
   {name :'Compans 77290'},
   {name:'Mitry-Mory 77290'}, 
  
  {name:'Fontainebleau 77300'},
  
  {name:'Boissise-le-Roi 77310'},
  {name:"Pringy 77310"},
  {name:'Saint-Fargeau-Ponthierry 77310 '},
  
   
  
  {name:"Beton-Bazoches 77320"},
  {name:"Cerneux 77320"},
  {name:"La Chapelle-Moutils 77320"},
  {name:"Chartronges 77320"},
  {name:"Chevru 77320"},
  {name:"Choisy-en-Brie 77320"},
  {name:"Dagny 77320"},
  {name:"La Ferté-Gaucher 77320"},
  {name:"Frétoy 77320"},
  {name:"Jouy-sur-Morin 77320"},
  {name:"Lescherolles 77320"},
  {name:"Leudon-en-Brie 77320"},
  {name:"Meilleray 77320"},
  {name:"Montdauphin 77320 "},
  {name:"Montenils 77320"},
  {name:"Montolivet 77320"},
  {name:"Saint-Barthélemy 77320"},
  {name:"Saint-Mars-Vieux-Maisons 77320"},
  {name:"Saint-Martin-des-Champs 77320"},
  {name:"Saint-Martin-du-Boschet 77320"},
  {name:"Saint-Rémy-la-Vanne 77320"},
  {name:"Sancy-lès-Provins 77320"}, 
  
  {name:"Ozoir-la-Ferrière 77330 "},
  
  {name:"Pontault-Combault 77340 "},
  
  {name:"Boissettes 77350"},
  {name:"Boissise-la-Bertrand 77350"},
   {name:"Le Mée-sur-Seine 77350"},
  
  {name:"Vaires-sur-Marne 77360"},
  
   
  
  {name:"La Chapelle-Rablais 77370 "},
   {name:"Châteaubleau 77370"},
   {name:"Clos-Fontaine 77370"},
   {name:"La Croix-en-Brie 77370"},
   {name:'Fontains 77370'},
   {name:"Fontenailles 77370"},
   {name:"Gastins 77370"},
   {name:"Maison-Rouge 77370"},
   {name:"Nangis 77370"},
   {name:"Rampillon 77370"},
   {name:"Saint-Just-en-Brie 77370"},
   {name:"Vanvillé 77370"},
   {name:"Vieux-Champagne 77370"},
  
   
  
  {name:"Combs-la-Ville 77380"} ,
  
  {name:"Andrezel 77390"},
   {name:"Argentières 77390"},
   {name:"Beauvoir 77390"},
   {name:"Champdeuil 77390"},
   {name:"Chaumes-en-Brie 77390"},
   {name:"Courquetaine 77390"},
   {name:"Courtomer 77390"},
   {name:"Crisenoy 77390"},
   {name:'Fouju 77390'},
   {name:"Guignes 77390"},
   {name:"Ozouer-le-Voulgis 77390"},
   {name:"Verneuil-l'Étang 77390"},
   {name:"Yèbles 77390"},
  
   
  
  {name:"Carnetin 77400"},
   {name:'Dampmart 77400'},
   {name:"Gouvernes 77400"},
   {name:"Lagny-sur-Marne 77400"},
   {name:"Pomponne 77400"},
   {name:"Saint-Thibault-des-Vignes 77400"},
   {name:"Thorigny-sur-Marne 77400"},
  
   
  
  {name:"Annet-sur-Marne 77410"},
   {name:"Charmentray 77410"},
   {name:"Charny 77410"},
   {name:"Claye-Souilly 77410"},
   {name:'Fresnes-sur-Marne 77410'},
   {name:"Gressy 77410"},
   {name:"Messy 77410"},
   {name:"Précy-sur-Marne 77410"},
   {name:"Saint-Mesmes 77410"},
   {name:"Villeroy 77410"},
   {name:"Villevaudé 77410"},
  
   
  
  {name:"Champs-sur-Marne 77420"},
  
   
  
  {name:"Champagne-sur-Seine 77430"},
  
   
  
  {name:"Armentières-en-Brie 77440"},
   {name:"Cocherel 77440 "},
   {name:"Congis-sur-Thérouanne 77440"},
   {name:"Dhuisy 77440"},
   {name:"Isles-les-Meldeuses 77440"},
   {name:"Jaignes 77440"},
   {name:"Lizy-sur-Ourcq 77440"},
   {name:"Mary-sur-Marne 77440"},
   {name:"Ocquerre 77440"},
   {name:"Le Plessis-Placy 77440"},
   {name:"Tancrou 77440"},
   {name:"Trocy-en-Multien 77440"},
   {name:"Vendrest 77440"},  
   
  
  {name:"Condé-Sainte-Libiaire 77450"},
   {name:"Esbly 77450"},
   {name:"Isles-lès-Villenoy 77450"},
   {name:"Jablines 77450"},
   {name:"Lesches 77450"},
   {name:"Montry 77450"},
   {name:"Trilbardou 77450"},
   {name:"Vignely 77450"},
  
   
  
  {name:"Chaintreaux 77460"},
   {name:"Souppes-sur-Loing 77460"},
  
   
  
  {name:"Boutigny 77470"},
   {name:"Fublaines 77470"},
   {name:"Montceaux-lès-Meaux 77470"},
   {name:"Poincy 77470"},
   {name:"Saint-Fiacre 77470"},
   {name:"Trilport 77470"},
   {name:"Villemareuil 77470"},
  
   
  
  {name:"Baby 77480"},
   {name:"Bray-sur-Seine 77480"},
   {name:"Fontaine-Fourches 77480"},
   {name:"Grisy-sur-Seine 77480"},
   {name:"Jaulnes 77480"},
   {name:"Montigny-le-Guesdier 77480"},
   {name:"Mousseaux-lès-Bray 77480"},
   {name:"Mouy-sur-Seine 77480"},
   {name:"Passy-sur-Seine 77480"},
   {name:"Saint-Sauveur-lès-Bray 77480"},
   {name:"Villenauxe-la-Petite 77480"},
   {name:"Villuis 77480"},
  
   
{name:"  Chelles 77500"},
  
  {name:"Bellot 77510"},
   {name:"Doue 77510"},
   {name:"Hondevilliers 77510"},
   {name:"Rebais 77510"},
   {name:"Sablonnières 77510"},
   {name:"Saint-Denis-lès-Rebais 77510"},
   {name:"Saint-Léger 77510"},
   {name:"La Trétoire 77510"},
   {name:"Verdelot 77510"},
   {name:"Villeneuve-sur-Bellot 77510"},
   
  
  {name:'La Celle-sur-Morin 77515'},
   {name:"Faremoutiers 77515"},
   {name:"Hautefeuille 77515"},
   {name:"Pommeuse 77515"},
   {name:'Saint-Augustin 77515'},
  
   
  
  {name:"Cessoy-en-Montois 77520"},
   {name:"Donnemarie-Dontilly 77520"},
   {name:'Gurcy-le-Châtel 77520'},
   {name:"Luisetaines 77520"},
   {name:"Meigneux 77520"},
   {name:"Mons-en-Montois 77520"},
   {name:"Montigny-Lencoup 77520"},
   {name:"Paroy 77520"},
   {name:"Sigy 77520"},
   {name:"Sognolles-en-Montois 77520"},
   {name:"Thénisy 77520"},
   {name:"Vimpelles 77520"},
  
   
  
  {name:"Bernay-Vilbert 77540"},
   {name:"La Chapelle-Iger 77540"},
   {name:"Courpalay 77540"},
   {name:"Lumigny-Nesles-Ormeaux 77540"},
   {name:"Le Plessis-Feu-Aussoux 77540"},
   {name:"Rozay-en-Brie 77540"},
   {name:"Voinsles 77540"},
  
   
  
  {name:"Limoges-Fourches 77550"},
   {name:"Lissy 77550"},
   {name:"Moissy-Cramayel 77550"},
   {name:"Réau 77550"},
  
   
  
  {name:"Augers-en-Brie 77560"},
   {name:"Beauchery-Saint-Martin 77560"},
   {name:"Champcenest 77560"},
   {name:"Courchamp 77560"},
   {name:"Courtacon 77560"},
   {name:"Louan-Villegruis-Fontaine 77560"},
   {name:"Les Marêts 77560"},
   {name:"Rupéreux 77560"},
   {name:"Villiers-Saint-Georges 77560"},
   {name:"Voulton 77560"},
  
   
  
  {name:"Aufferville 77570"},
   {name:"Bougligny 77570"},
   {name:"Château-Landon 77570"},
   {name:"Chenou 77570"},
   {name:"La Madeleine-sur-Loing 77570"},
   {name:"Maisoncelles-en-Gâtinais 77570"},
   {name:"Mondreville 77570"},
  
   
  
  {name:"Bouleurs 77580"},
   {name:"Coulommes 77580"},
   {name:"Coutevroult 77580"},
   {name:"Crécy-la-Chapelle 77580"},
   {name:"Guérard 77580"},
   {name:"La Haute-Maison 77580"},
   {name:"Maisoncelles-en-Brie 77580"},
   {name:"Pierre-Levée 77580"},
   {name:"Sancy 77580"},
   {name:"Vaucourtois 77580"},
   {name:"Villiers-sur-Morin 77580"},
   {name:"Voulangis 77580"},
  
   
  
  {name:"Bois-le-Roi 77590"},
   {name:"Chartrettes 77590"},
   {name:"Fontaine-le-Port 77590"},
  
   
  
  {name:"Bussy-Saint-Georges 77600"},
   {name:"Bussy-Saint-Martin 77600"},
   {name:"Chanteloup-en-Brie 77600"},
   {name:"Conches-sur-Gondoire 77600"},
   {name:"Guermantes 77600"},
   {name:"Jossigny 77600"},
  
   
  
  {name:"Les Chapelles-Bourbon 77610"},
   {name:"Châtres 77610"},
   {name:"Crèvecoeur-en-Brie 77610"},
   {name:"Fontenay-Trésigny 77610"},
   {name:"La Houssaye-en-Brie 77610"},
   {name:"Marles-en-Brie 77610"},
   {name:"Neufmoutiers-en-Brie 77610"},
  
   
  
  {name:"Bransles 77620"},
   {name:"Égreville 77620"},
  
   
  
  {name:"Arbonne-la-Forêt 77630"},
   {name:"Barbizon 77630"},
   {name:"Saint-Martin-en-Bière 77630"},
  
   
  
  {name:"Jouarre 77640"},
   {name:"Signy-Signets 77640"},
  
   
  
  {name:"Chalmaison 77650"},
   {name:"Jutigny 77650"},
   {name:"Lizines 77650"},
   {name:"Longueville 77650"},
   {name:"Sainte-Colombe 77650"},
   {name:"Saint-Loup-de-Naud 77650"},
   {name:"Savins 77650"},
   {name:"Soisy-Bouy 77650"},
  
   
  
  {name:"Changis-sur-Marne 77660"},
   {name:"Saint-Jean-les-Deux-Jumeaux 77660"},
  
   
  
  {name:"Saint-Mammès 77670"},
   {name:'Vernou-la-Celle-sur-Seine 77670'},
  
   
  
  {name:"Roissy-en-Brie 77680"},
  
   
  
  {name:"La Genevraye 77690"},
   {name:"Montigny-sur-Loing 77690"},
  
   
  
  {name:"Bailly-Romainvilliers 77700"},
   {name:"Chessy 77700"},
   {name:"Coupvray 77700"},
   {name:'Magny-le-Hongre 77700'},
   {name:"Serris 77700"},
  
   
  
  {name:"Chevry-en-Sereine 77710"},
   {name:"Lorrez-le-Bocage-Préaux 77710"},
   {name:"Nanteau-sur-Lunain 77710"},
   {name:'Paley 77710'},
   {name:"Remauville 77710"},
   {name:"Saint-Ange-le-Viel 77710"},
   {name:'Treuzy-Levelay 77710'},
   {name:"Vaux-sur-Lunain 77710"},
   {name:"Villebéon 77710"},
   {name:'Villemaréchal 77710'},
  
   
  
  {name:"Aubepierre-Ozouer-le-Repos 77720"},
   {name:"Bombon 77720"},
   {name:"Bréau 77720"},
   {name:"Champeaux 77720"},
   {name:"La Chapelle-Gauthier 77720"},
   {name:"Grandpuits-Bailly-Carrois 77720"},
   {name:'Mormant 77720'},
   {name:"Quiers 77720"},
   {name:"Saint-Méry 77720"},
   {name:"Saint-Ouen-en-Brie 77720"},
  
   
  
  {name:"Citry 77730"},
   {name:"Méry-sur-Marne 77730"},
   {name:"Nanteuil-sur-Marne 77730"},
   {name:"Saâcy-sur-Marne 77730"},
  
   
  
  {name:"Bassevelle 77750"},
   {name:"Boitron 77750"},
   {name:"Bussières 77750"},
   {name:"Orly-sur-Morin 77750"},
   {name:"Saint-Cyr-sur-Morin 77750"},
   {name:"Saint-Ouen-sur-Morin 77750"},
  
   
  
  {name:"Achères-la-Forêt 77760"},
   {name:"Amponville 77760"},
   {name:"Boissy-aux-Cailles 77760"},
   {name:"Boulancourt 77760"},
   {name:"Burcy 77760"},
   {name:"Buthiers 77760"},
   {name:"La Chapelle-la-Reine 77760"},
   {name:"Chevrainvilliers 77760"},
   {name:"Fromont 77760"},
   {name:"Guercheville 77760"},
   {name:"Larchant 77760"},
   {name:"Nanteau-sur-Essonne 77760"},
   {name:"Recloses 77760"},
   {name:"Rumont 77760"},
   {name:'Ury 77760'},
   {name:"Villiers-sous-Grez 77760"},
  
   
  
  {name:"Bourron-Marlotte 77780"},
  
   
  
  {name:"Thomery 77810"},
  
   
  
  {name:"Le Châtelet-en-Brie 77820"},
   {name:"Châtillon-la-Borde 77820"},
   {name:"Les Écrennes 77820"},
  
   
  
  {name:"Échouboulains 77830"},
   {name:"Pamfou 77830"},
   {name:"Valence-en-Brie 77830"},
  
   
  
  {name:"Coulombs-en-Valois 77840"},
   {name:"Crouy-sur-Ourcq 77840"},
   {name:"Germigny-sous-Coulombs 77840"},
  
   
  
  {name:"Héricy 77850"},
  
  {name:"Couilly-Pont-aux-Dames 77850"},
   {name:"Quincy-Voisins 77850 "},
   {name:"Saint-Germain-sur-Morin 77850"},
  
   
  
  {name:"Vulaines-sur-Seine 77870"},
  
   
  
  {name:"Grez-sur-Loing 77880"},
  
   
  
  {name:"Arville 77890"},
   {name:"Beaumont-du-Gâtinais 77890"},
   {name:"Garentreville 77890"},
   {name:"Gironville 77890"},
   {name:"Ichy 77890"},
   {name:"Obsonville 77890"},
  
   
  
  {name:"Barcy 77910"},
   {name:"Chambry 77910"},
   {name:"Germigny-l'Évêque 77910"},
   {name:"Varreddes 77910"},
  
   
  
  {name:"Samois-sur-Seine 77920"},
  
   
  
  {name:"Cély 77930"},
   {name:"Chailly-en-Bière 77930"},
   {name:"Fleury-en-Bière 77930"},
   {name:'Perthes 77930'},
   {name:'Saint-Germain-sur-École 77930'},
   {name:"Saint-Sauveur-sur-École 77930"},
  
   
  
  {name:'Blennes 77940'},
   {name:'La Brosse-Montceaux 77940'},
   {name:"Diant 77940"},
   {name:"Esmans 77940"},
   {name:"Flagy 77940"},
   {name:"Montmachoux 77940"},
   {name:"Noisy-Rudignon 77940"},
   {name:"Thoury-Férottes 77940"},
   {name:"Voulx 77940"},
  
   
  
  {name:"Maincy 77950"},
   {name:"Moisenay 77950"},
   {name:"Montereau-sur-le-Jard 77950"},
   {name:"Rubelles 77950"},
   {name:"Saint-Germain-Laxis 77950"},
   {name:"Voisenon 77950"},
  
   
  
  {name:"Bannost-Villegagnon 77970"},
   {name:"Bezalles 77970"},
   {name:"Boisdon 77970"},
   {name:"Jouy-le-Châtel 77970"},
   {name:"Pécy 77970"},
  
   
  
  {name:"Mauregard 77990"},
   {name:'Le Mesnil-Amelot 77990'},
  
   
  
  {name:"Versailles 78000"},
  
   
  
  {name:"Saint-Germain-en-Laye 78100"},
  
   
  
  {name:"Le Vésinet 78110"},
  
   
  
  {name:"Dammartin-en-Serve 78111 "},
  
  {name:"Fourqueux 78112"},
  
   
  
  {name:"Adainville 78113"},
   {name:"Bourdonné 78113"},
   {name:"Condé-sur-Vesgre 78113"},
   {name:"Grandchamp 78113"},
   {name:"La Hauteville 78113"},
   {name:"Le Tartre-Gaudran 78113 "},
  
  {name:"Magny-les-Hameaux 78114"},
  
   
  
  {name:"Châteaufort 78117"},
   {name:"Toussus-le-Noble 78117"},
  
   
  
  {name:"Clairefontaine-en-Yvelines 78120"},
   {name:"Rambouillet 78120"},
   {name:'Sonchamp 78120'},
  
   
  
  {name:"Crespières 78121"},
  
   
  
  {name:"Mareil-sur-Mauldre 78124"},
   {name:"Montainville 78124"},
  
   
  
  {name:"La Boissière-École 78125"},
  {name:" Émancé 78125"},
   {name:"Gazeran 78125"},
   {name:"Hermeray 78125"},
   {name:"Mittainville 78125"},
   {name:"Orcemont 78125"},
   {name:"Orphin 78125"},
   {name:"Poigny-la-Forêt 78125"},
   {name:"Raizeux 78125"},
   {name:"Saint-Hilarion 78125"},
   {name:"Vieille-Église-en-Yvelines 78125"},
  
   
  
  {name:"Aulnay-sur-Mauldre 78126"},
  
   
  
  {name:"Chapet 78130"},
   {name:"Les Mureaux 78130"},
  
   
  
  {name:"Vélizy-Villacoublay 78140"},
  
   
  
  {name:"Le Chesnay 78150"},
   {name:"Rocquencourt 78150"},
  
   
  
  {name:"Marly-le-Roi 78160"},
  
   
  
  {name:"La Celle-Saint-Cloud 78170"},
  
   
  
  {name:"Montigny-le-Bretonneux 78180"},
  
   
  
  {name:"Trappes 78190"},
  
   
  
{name:"  Boinvilliers 78200"},
   {name:"Boissy-Mauvoisin 78200"},
   {name:"Buchelay 78200"},
   {name:"Favrieux 78200"},
   {name:"Flacourt 78200"},
   {name:"Fontenay-Mauvoisin 78200"},
   {name:"Jouy-Mauvoisin 78200"},
   {name:"Magnanville 78200"},
   {name:"Mantes-la-Jolie 78200"},
   {name:"Ménerville 78200"},
   {name:"Perdreauville 78200"},
   {name:"Soindres 78200"},
  
   
  
  {name:"Saint-Cyr-l'École 78210"},
  
   
  
  {name:"Viroflay 78220"},
  
   
  
  {name:"Le Pecq 78230"},
  
   
  
  {name:"Aigremont 78240"},
   {name:"Chambourcy 78240"},
  
   
  
  {name:"Gaillon-sur-Montcient 78250"},
   {name:"Hardricourt 78250"},
   {name:"Meulan-en-Yvelines 78250"},
   {name:"Mézy-sur-Seine 78250"},
   {name:"Oinville-sur-Montcient 78250"},
   {name:"Tessancourt-sur-Aubette 78250"},
  
   
  
  {name:"Achères 78260"},
  
   
  
  {name:"Bennecourt 78270"},
   {name:"Blaru 78270"},
   {name:"Bonnières-sur-Seine 78270"},
   {name:"Chaufour-lès-Bonnières 78270"},
   {name:"Cravent 78270"},
   {name:"Gommecourt 78270"},
   {name:"Jeufosse 78270"},
   {name:"Limetz-Villez 78270"},
   {name:"Lommoye 78270"},
   {name:"Méricourt 78270"},
   {name:"Mousseaux-sur-Seine 78270"},
   {name:"Port-Villez 78270"},
   {name:"Rolleboise 78270"},
   {name:'La Villeneuve-en-Chevrie 78270'},
  
   
  
  {name:"Guyancourt 78280"},
  
   
  
  {name:"Croissy-sur-Seine 78290"},
  
   
  {name:"Poissy 78300"},
  
   
  
  {name:"Coignières 78310"},
   {name:"Maurepas 78310"},
  
   
  
  {name:"Lévis-Saint-Nom 78320"},
   {name:"Le Mesnil-Saint-Denis 78320"},
   {name:"La Verrière 78320"},
  
   
  
  {name:"Fontenay-le-Fleury 78330"},
  
   
  
  {name:"Les Clayes-sous-Bois 78340"},
  
   
  
  {name:"Jouy-en-Josas 78350"},
   {name:"Les Loges-en-Josas 78350"},
  
   
  
  {name:"Montesson 78360"},
  
   
  
  {name:"Plaisir 78370"},
  
   
  
  {name:"Bougival 78380"},
  
   
  
  {name:"Bois-d'Arcy 78390"},
  
  
  
  {name:"Chatou  78400 "},
  
   
  
  {name:"Aubergenville 78410"},
   {name:"Bouafle 78410"},
   {name:"La Falaise 78410"},
   {name:"Flins-sur-Seine 78410"},
   {name:"Nézel 78410"},
  
   
  
  {name:'Carrières-sur-Seine 78420 '},
  
   
  
  {name:"Louveciennes 78430"},
  
   
  
  {name:"Brueil-en-Vexin 78440"},
   {name:'Drocourt 78440'},
   {name:'Fontenay-Saint-Père 78440'},
   {name:"Gargenville 78440"},
   {name:"Guitrancourt 78440"},
   {name:"Issou 78440"},
   {name:"Jambville 78440"},
   {name:"Lainville-en-Vexin 78440"},
   {name:"Montalet-le-Bois 78440"},
   {name:"Porcheville 78440"},
   {name:"Sailly 78440"},
  
   
  
  {name:"Chavenay 78450"},
   {name:"Villepreux 78450"},
  
   
  
  {name:"Chevreuse 78460"},
   {name:"Choisel 78460"},
  
   
  
  {name:"Milon-la-Chapelle 78470"},
   {name:'Saint-Lambert 78470'},
   {name:"Saint-Rémy-lès-Chevreuse 78470"},
  
   
  
  {name:"Verneuil-sur-Seine 78480"},
  
   
  
  {name:"Bazoches-sur-Guyonne 78490"},
   {name:"Boissy-sans-Avoir 78490"},
   {name:"Galluis 78490"},
   {name:"Gambaiseuil 78490"},
   {name:"Grosrouvre 78490"},
   {name:"Mareil-le-Guyon 78490"},
   {name:"Méré 78490"},
   {name:"Les Mesnuls 78490"},
   {name:"Montfort-l'Amaury 78490"},
   {name:'Le Tremblay-sur-Mauldre 78490'},
   {name:"Vicq 78490"},
  
   
  
  {name:"Sartrouville 78500"},
  
   
  
  {name:"Triel-sur-Seine 78510"},
  
   
  
  {name:"Follainville-Dennemont 78520"},
   {name:"Guernes 78520"},
   {name:"Limay 78520"},
   {name:"Saint-Martin-la-Garenne 78520"},
  
   
  
  {name:"Buc 78530"},
  
   
  
  {name:"Vernouillet 78540"},
  
   
  
  {name:"Bazainville 78550"},
   {name:"Dannemarie 78550"},
   {name:"Gressey 78550"},
   {name:"Houdan 78550"},
   {name:"Maulette 78550"},
   {name:"Richebourg 78550"},
  
   
  
  {name:"Le Port-Marly 78560"},
  
   
  
  {name:"Andrésy 78570"},
   {name:"Chanteloup-les-Vignes 78570"},
  
   
  
  {name:'Les Alluets-le-Roi 78580'},
   {name:"Bazemont 78580"},
   {name:"Herbeville 78580"},
   {name:"Jumeauville 78580"},
   {name:"Maule 78580"},
  
   
  
  {name:"Noisy-le-Roi 78590"},
   {name:"Rennemoulin 78590"},
  
   
  
  {name:"Maisons-Laffitte 78600"},
   {name:"Le Mesnil-le-Roi 78600"},
  
   
  
  {name:"Auffargis 78610"},
   {name:"Les Bréviaires 78610"},
   {name:"Le Perray-en-Yvelines 78610"},
   {name:"Saint-Léger-en-Yvelines 78610"},
  
   
  
  {name:"L' Étang-la-Ville 78620"},
  
   
  
  {name:"Morainvilliers 78630"},
   {name:"Orgeval 78630"},
  
   
  
  {name:"Neauphle-le-Château 78640"},
   {name:"Neauphle-le-Vieux 78640"},
   {name:"Saint-Germain-de-la-Grange 78640"},
   {name:"Villiers-Saint-Fréderic 78640"},
  
   
  
  {name:"Beynes 78650"},
   {name:"Saulx-Marchais 78650"},
  
   
  
  {name:"Ablis 78660"},
   {name:"Allainville 78660"},
   {name:"Boinville-le-Gaillard 78660"},
   {name:"Orsonville 78660"},
   {name:"Paray-Douaville 78660"},
   {name:"Prunay-en-Yvelines 78660"},
   {name:"Saint-Martin-de-Bréthencourt 78660"},
  
   
  
  {name:"Médan 78670"},
   {name:"Villennes-sur-Seine 78670 "},
  
   
  
  {name:"Épône 78680"},
  
   
  
  {name:"Les Essarts-le-Roi 78690"},
   {name:"Saint-Rémy-l'Honoré 78690"},
  
   
  
  {name:"Conflans-Sainte-Honorine 78700"},
  
   
  
  {name:"Rosny-sur-Seine 78710"},
  
   
  
  {name:"Mantes-la-Ville 78711"},
  
   
  
  {name:'La Celle-les-Bordes 78720'},
   {name:"Cernay-la-Ville 78720"},
   {name:"Dampierre-en-Yvelines 78720"},
   {name:"Saint-Forget 78720"},
   {name:"Senlisse 78720"},
  
   
  
  {name:"Longvilliers  78730"},
   {name:"Ponthévrard 78730"},
   {name:"Rochefort-en-Yvelines 78730"},
   {name:"Saint-Arnoult-en-Yvelines 78730"},
   {name:"Sainte-Mesme 78730"},
  
   
  
  {name:"Évecquemont 78740"},
   {name:"Vaux-sur-Seine 78740"},
  
   
  
  {name:"Mareil-Marly 78750"},
  
   
  
  {name:"Jouars-Pontchartrain 78760"},
  
   
  
  {name:"Andelu 78770"},
   {name:'Auteuil 78770 '},
   {name:"Autouillet 78770"},
   {name:"Goupillières 78770"},
   {name:"Marcq 78770"},
   {name:"Thoiry 78770"},
   {name:"Villiers-le-Mahieu 78770"},
  
   
  
  {name:"Maurecourt 78780"},
  
   
  
  {name:"Arnouville-lès-Mantes 78790"},
   {name:'Courgent 78790'},
   {name:'Flins-Neuve-Église 78790'},
   {name:"Hargeville 78790"},
   {name:'Montchauvet 78790'},
   {name:'Mulcent 78790'},
   {name:"Rosay 78790"},
 {name:' Saint-Martin-des-Champs 78790'},
   {name:"Septeuil 78790"},
   {name:"Tilly 78790"},
  
   
  
  {name:"Houilles 78800"},
  
   
  
  {name:"Davron 78810"},
   {name:"Feucherolles 78810"},
  
   
  
  {name:"Juziers 78820"},
  
   
  
  {name:"Bonnelles 78830"},
   {name:"Bullion 78830"},
  
   
  
  {name:"Freneuse 78840"},
   {name:"Moisson 78840"},
  
   
  
  {name:"Thiverval-Grignon 78850"},
  
   
  
  {name:"Saint-Nom-la-Bretèche 78860"},
  
   
  
  {name:"Bailly 78870"},
  
   
  
  {name:"Garancières 78890"},
  
   
  
  {name:"Béhoust 78910"},
   {name:"Boissets 78910"},
   {name:"Civry-la-Forêt 78910"},
  {name:"Flexanville 78910"},
   {name:"Orgerus 78910"},
   {name:"Orvilliers 78910"},
   {name:"Osmoy 78910"},
   {name:"Prunay-le-Temple 78910"},
   {name:"Tacoignières 78910"},
  
   
  
  {name:"Ecquevilly 78920"},
  
   
  
  {name:"Auffreville-Brasseuil 78930"},
   {name:"Boinville-en-Mantois 78930"},
   {name:"Breuil-Bois-Robert 78930"},
   {name:"Goussonville 78930"},
   {name:"Guerville 78930"},
   {name:"Vert 78930"},
   {name:"Villette 78930"},
  
   
  
  {name:"Millemont 78940"},
   {name:"La Queue-les-Yvelines 78940"},
  
   
  
  {name:"Gambais 78950"},
  
   
  
  {name:"Carrières-sous-Poissy 78955"},
  
   
  
  {name:"Voisins-le-Bretonneux 78960"},
  
   
  
  {name:"Mézières-sur-Seine 78970"},
  
   
  
  {name:"Bréval 78980"},
   {name:"Longnes 78980"},
   {name:"Mondreville 78980"},
   {name:"Neauphlette 78980"},
   {name:"Saint-Illiers-la-Ville 78980"},
   {name:"Saint-Illiers-le-Bois 78980"},
   {name:"Le Tertre-Saint-Denis 78980"},
  
   
  
  {name:"Élancourt 78990"},
  
   
  
  {name:"Évry 91000"},
  
   
  
  {name:"Bondoufle 91070"},
  
   
  
  {name:"Courcouronnes 91080"},
  
   
  
  {name:"Lisses 91090"},
  
   
  
  {name:"Corbeil-Essonnes 91100"},
   {name:'Villabé 91100'},
  
   
  
  {name:'Palaiseau 91120'},
  
   
  
  {name:"Ris-Orangis 91130"},
  
   
  
  {name:"Villebon-sur-Yvette 91140"},
   {name:"Villejust 91140"},
  
   
  
  {name:"Abbéville-la-Rivière 91150"},
   {name:"Blandy 91150"},
   {name:"Bois-Herpin 91150"},
   {name:"Boutervilliers 91150"},
   {name:"Brières-les-Scellés 91150"},
   {name:"Brouy 91150"},
   {name:"Champmotteux 91150"},
   {name:"Étampes 91150"},
   {name:'La Forêt-Sainte-Croix 91150'},
   {name:"Marolles-en-Beauce 91150"},
   {name:"Mespuits 91150"},
   {name:"Morigny-Champigny 91150"},
   {name:"Ormoy-la-Rivière 91150"},
   {name:"Puiselet-le-Marais 91150"},
   {name:"Roinvilliers 91150"},
  
   
  
  {name:"Ballainvilliers 91160"},
   {name:"Champlan 91160"},
   {name:"Longjumeau 91160"},
   {name:"Saulx-les-Chartreux 91160"},
  
   
  
  {name:"Viry-Châtillon 91170"},
  
   
  
  {name:"Saint-Germain-lès-Arpajon 91180"},
  
   
  
  {name:"Gif-sur-Yvette 91190"},
   {name:"Saint-Aubin 91190"},
   {name:"Villiers-le-Bâcle 91190"},
  
   
  
  {name:"Athis-Mons 91200"},
  
   
  
  {name:"Draveil 91210"},
  
   
  
  {name:"Brétigny-sur-Orge 91220"},
   {name:"Le Plessis-Pâté 91220"},
  
   
  
  {name:"Montgeron 91230"},
  
   
  
  {name:"Saint-Michel-sur-Orge 91240"},
  
   
  
  {name:"Morsang-sur-Seine 91250"},
   {name:"Saint-Germain-lès-Corbeil 91250"},
   {name:"Saintry-sur-Seine 91250"},
   {name:"Tigery 91250"},
  
   
  
  {name:"Juvisy-sur-Orge 91260"},
  
   
  
 {name:" Vigneux-sur-Seine 91270"},
  
   
  
  {name:"Saint-Pierre-du-Perray 91280"},
  
   
  
  {name:"Arpajon 91290"},
   {name:"La Norville 91290"},
  
   
  
  {name:"Massy 91300"},
  
   
  
  {name:"Leuville-sur-Orge 91310"},
   {name:"Linas 91310"},
   {name:"Longpont-sur-Orge 91310"},
   {name:"Montlhéry 91310"},
  
   
  
  {name:"Wissous 91320"},
  
   
  
  {name:"Yerres 91330"},
  
   
  
  {name:"Ollainville 91340"},
  
   
  
  {name:"Grigny 91350"},
  
   
  
  {name:"Épinay-sur-Orge 91360"},
   {name:"Villemoisson-sur-Orge 91360"},
  
   
  
  {name:"Verrières-le-Buisson 91370"},
  
   
  
  {name:"Chilly-Mazarin 91380"},
  
   
  
  {name:"Morsang-sur-Orge 91390"},
  
   
  
  {name:"Gometz-la-Ville 91400"},
   {name:"Orsay 91400"},
   {name:"Saclay 91400"},
  
   
  
  {name:"Authon-la-Plaine 91410"},
   {name:"Chatignonville 91410"},
   {name:"Corbreuse 91410"},
   {name:"Dourdan 91410"},
   {name:"La Forêt-le-Roi 91410"},
   {name:"Les Granges-le-Roi 91410"},
   {name:"Plessis-Saint-Benoist 91410"},
   {name:"Richarville 91410"},
   {name:"Roinville 91410"},
   {name:"Saint-Cyr-sous-Dourdan 91410"},
   {name:"Saint-Escobille 91410"},
  
   
  
  {name:"Morangis 91420"},
  
  
  {name:"Igny 91430"},
   {name:"Vauhallan 91430"},
  
  
  
  {name:"Bures-sur-Yvette 91440 "},
  
   
  
  {name:"Étiolles 91450"},
   {name:"Soisy-sur-Seine 91450"},
  
   
  
  {name:"Marcoussis 91460"},
  
   
  
  {name:"Angervilliers 91470"},
   {name:"Boullay-les-Troux 91470"},
   {name:"Forges-les-Bains 91470"},
   {name:'Limours 91470'},
   {name:"Les Molières 91470"},
   {name:"Pecqueuse 91470"},
  
   
  
  {name:"Quincy-sous-Sénart 91480"},
   {name:"Varennes-Jarcy 91480"},
  
   
  
  {name:"Courances 91490"},
   {name:"Dannemois 91490"},
   {name:"Milly-la-Forêt 91490"},
   {name:"Moigny-sur-École 91490"},
   {name:"Oncy-sur-École 91490"},
  
   
  
  {name:"Janville-sur-Juine 91510"},
   {name:"Lardy 91510"},
  
  
  {name:'Égly 91520 '},

  
   
  
  {name:"Saint-Chéron 91530"},
   {name:"Saint-Maurice-Montcouronne 91530 "},
   {name:"Sermaise 91530"},
   {name:'Le Val-Saint-Germain 91530'},
  
   
  
  {name:"Écharcon 91540"},
   {name:"Fontenay-le-Vicomte 91540"},
   {name:'Mennecy 91540'},
   {name:"Ormoy 91540"},
  
   
  
  {name:"Paray-Vieille-Poste 91550"},
  
   
  
  {name:"Crosne 91560"},
  
   
  
  {name:"Bièvres 91570"},
  
   
  
  {name:"Auvers-Saint-Georges 91580"},
   {name:"Chauffour-lès-Étréchy 91580"},
   {name:"Étréchy 91580"},
   {name:"Souzy-la-Briche 91580"},
   {name:"Villeconin 91580"},
   {name:"Villeneuve-sur-Auvers 91580"},
  
   
  
  {name:"Baulne 91590"},
   {name:"Boissy-le-Cutté 91590"},
   {name:"Cerny 91590"},
   {name:"D'Huison-Longueville 91590"},
   {name:"La Ferté-Alais 91590"},
   {name:"Guigneville-sur-Essonne 91590"},
   {name:"Mondeville 91590"},
   {name:"Orveau 91590"},
  
   
  
  {name:"Savigny-sur-Orge 91600"},
  
   
  
  {name:"Ballancourt-sur-Essonne 91610"},
  
   
  
  {name:"Nozay 91620"},
   {name:"La Ville-du-Bois 91620"},
  
   
  
  {name:"Avrainville 91630"},
   {name:"Cheptainville 91630"},
   {name:"Guibeville 91630"},
   {name:"Leudeville 91630"},
   {name:"Marolles-en-Hurepoix 91630"},
  
   
  
  {name:"Briis-sous-Forges 91640"},
   {name:"Fontenay-lès-Briis 91640"},
   {name:"Janvry 91640"},
   {name:"Vaugrigneuse 91640"},
  
   
  
  {name:"Breuillet 91650"},
   {name:"Breux-Jouy 91650"},
   {name:"Saint-Yon 91650"},
  
   
  
  {name:"Estouches 91660"},
   {name:"Méréville 91660"},
  
   
  
  {name:"Angerville 91670"},
  
   
  
  {name:"Bruyères-le-Châtel 91680"},
   {name:"Courson-Monteloup 91680"},
  
   
  
  {name:"Arrancourt 91690"},
   {name:"Boissy-la-Rivière 91690"},
   {name:"Fontaine-la-Rivière 91690"},
   {name:"Guillerval 91690"},
   {name:"Saclas 91690"},
   {name:"Saint-Cyr-la-Rivière 91690 "},
  
   
  
  {name:"Fleury-Mérogis 91700"},
   {name:"Sainte-Geneviève-des-Bois 91700"},
   {name:"Villiers-sur-Orge 91700"},
  
   
  
  {name:"Vert-le-Petit 91710"},
  
   
  
  {name:"Boigneville 91720"},
   {name:"Buno-Bonnevaux 91720"},
   {name:"Courdimanche-sur-Essonne 91720"},
   {name:"Gironville-sur-Essonne 91720"},
   {name:"Maisse 91720"},
   {name:"Prunay-sur-Essonne 91720"},
   {name:"Valpuiseaux 91720"},
  
   
  
  {name:"Chamarande 91730"},
   {name:"Mauchamps 91730"},
   {name:"Torfou 91730"},
  
   
  
  {name:"Chalou-Moulineux 91740"},
   {name:'Pussay 91740'},
   {name:"Congerville-Thionville 91740"},
  
   
  
  {name:"Champcueil 91750"},
   {name:"Chevannes 91750"},
   {name:'Nainville-les-Roches 91750'},
  
   
  
  {name:"Itteville 91760"},
  
   
  
  {name:"Saint-Vrain 91770"},
  
   
  
  {name:"Chalo-Saint-Mars 91780"},
   {name:'Mérobert 91780'},
   {name:'Saint-Hilaire 91780'},
  
   
  
  {name:"Boissy-sous-Saint-Yon 91790"},
  
   
  
  {name:"Boussy-Saint-Antoine 91800"},
   {name:'Brunoy 91800'},
  
   
  
  {name:"Vert-le-Grand 91810"},
  
   
  
  {name:'Boutigny-sur-Essonne 91820'},
   {name:"Vayres-sur-Essonne 91820"},
  
   
  
  {name:"Auvernaux 91830"},
   {name:"Le Coudray-Montceaux 91830"},
  
   
  
  {name:"Soisy-sur-École 91840"},
  
   
  
  {name:"Bouray-sur-Juine 91850"},
  
   
  
  {name:'Épinay-sous-Sénart 91860'},
  
   
  
  {name:"Boissy-le-Sec 91870"},
  
   
  
  {name:"Bouville 91880"},
  
   
  
 {name:' Videlles 91890'},
  
   
  
  {name:"Saint-Sulpice-de-Favières 91910"},
  
   
  
  {name:"Monnerville 91930"},
  
   
  
  {name:"Gometz-le-Châtel 91940 "},
   {name:'Saint-Jean-de-Beauregard 91940'},
   {name:'Les Ulis 91940'},
  
   
  
  {name:"Nanterre 92000"},
  
   
  
  {name:"Boulogne-Billancourt 92100"},
  
   
  
  {name:"Clichy 92110"},
  
   
  
  {name:"Montrouge 92120"},
  
   
  
  {name:"Issy-les-Moulineaux 92130"},
  
   
  
  {name:'Clamart 92140'},
  
   
  
  {name:"Suresnes 92150"},
  
   
  
  {name:"Antony 92160"},
  
   
  
  {name:'Vanves 92170'},
  
   
  
  {name:"Meudon 92190"},
  
   
  
  {name:"Neuilly-sur-Seine 92200"},
  
   
  
  {name:"Saint-Cloud 92210"},
  
   
  
  {name:"Bagneux 92220"},
  
   
  
  {name:"Gennevilliers 92230"},
  
   
  
  {name:"Malakoff 92240"},
  
   
  
  {name:"La Garenne-Colombes 92250"},
  
   
  
  {name:"Fontenay-aux-Roses 92260"},
  
   
  
  {name:"Bois-Colombes 92270"},
  
   
  
 {name:" Châtenay-Malabry 92290"},
  
   
  
  {name:"Levallois-Perret 92300"},
  
   
  
  {name:"Sèvres 92310"},
  
   
  
  {name:"Châtillon 92320"},
  
   
  
  {name:"Sceaux 92330"},
  
   
  
  {name:"Bourg-la-Reine 92340"},
  
   
  
  {name:'Le Plessis-Robinson 92350'},
  
   
  
  {name:'Chaville 92370'},
  
   
  
  {name:'Garches 92380'},
  
   
  
  {name:'Villeneuve-la-Garenne 92390'},
  
   
  
  {name:"Courbevoie 92400 "},
  
   
  
  {name:"Ville-d'Avray 92410"},
  
   
  
  {name:"Vaucresson 92420"},
  
   
  
  {name:"Marnes-la-Coquette 92430"},
  
   
  
  {name:"Rueil-Malmaison 92500"},
  
   
  
  {name:"Asnières-sur-Seine 92600"},
  
   
  
  {name:"Colombes 92700"},
  
  
  {name:"Puteaux 92800"},
   
  
   
  
  {name:"Bobigny 93000"},
  
   
  
  {name:"Montreuil 93100"},
  
   
  
  {name:"Rosny-sous-Bois 93110"},
  
   
  
  {name:"La Courneuve 93120"},
  
   
  
  {name:"Noisy-le-Sec 93130"},
  
   
  
  {name:"Bondy 93140"},
  
   
  
  {name:"Le Blanc-Mesnil 93150"},
  
   
  
  {name:"Noisy-le-Grand 93160"},
  
   
  
  {name:"Bagnolet 93170"},
  
   
  
  {name:"Livry-Gargan 93190"},
  
   
  
  {name:"Saint-Denis 93200"},
  
   
  
  {name:"Gagny 93220"},
  
   
  
  {name:"Romainville 93230"},
  
   
  
  {name:"Stains 93240"},
  
   
  
  {name:"Villemomble 93250"},
  
   
  
  {name:"Les Lilas 93260"},
  
   
  
  {name:"Sevran 93270"},
  
   
  
  {name:"Tremblay-en-France 93290"},
  
   
  
  {name:"Aubervilliers 93300"},
  
   
  
  {name:"Le Pré-Saint-Gervais 93310"},
  
   
  
  {name:"Les Pavillons-sous-Bois 93320"},
  
   
  
  {name:"Neuilly-sur-Marne 93330"},
  
   
  
  {name:"Le Raincy 93340"},
  
   
  
  {name:'Le Bourget 93350'},
  
   
  
  {name:"Neuilly-Plaisance 93360"},
  
   
  
  {name:"Montfermeil 93370"},
  
   
  
  {name:"Pierrefitte-sur-Seine 93380"},
  
   
  
  {name:"Clichy-sous-Bois 93390"},
  
   
  
  {name:"Saint-Ouen 93400"},
  
   
  
  {name:"Vaujours 93410"},
  
   
  
  {name:"Villepinte 93420"},
  
   
  
  {name:"Villetaneuse 93430"},
  
   
  
  {name:"Dugny 93440"},
  
   
  
  {name:"L' Île-Saint-Denis 93450"},
  
   
  
  {name:"Gournay-sur-Marne 93460"},
  
   
  
  {name:"Coubron 93470"},
  
   
  
  {name:"Pantin 93500"},
  
   
  
  {name:"Aulnay-sous-Bois 93600"},
  
   
  
  {name:"Drancy 93700"},
  
   
  
  {name:'Épinay-sur-Seine 93800'},
  
   
  
  {name:"Créteil 94000"},
  
   
  
  {name:"Saint-Maur-des-Fossés 94100"},
  
   
  
  {name:"Arcueil 94110"},
  
   
  
  {name:"Fontenay-sous-Bois 94120"},
  
   
  
  {name:"Nogent-sur-Marne 94130"},
  
   
  
  {name:"Alfortville 94140"},
  
   
  
  {name:"Rungis 94150"},
  
   
  
  {name:"Saint-Mandé 94160"},
  
   
  
  {name:"Le Perreux-sur-Marne 94170"},
  
   
  
  {name:"Villeneuve-Saint-Georges 94190"},
  
   
  
  {name:"Ivry-sur-Seine 94200"},
  
   
  
  {name:"Charenton-le-Pont 94220"},
  
   
  
  {name:"Cachan 94230"},
  
   
  
  {name:"L' Haÿ-les-Roses 94240"},
  
   
  
  {name:"Gentilly 94250"},
  
   
  
  {name:"Fresnes 94260"},
  
   
  
  {name:"Le Kremlin-Bicêtre 94270"},
  
   
  
  {name:"Villeneuve-le-Roi 94290"},
  
   
  
  {name:"Vincennes 94300"},
  
   
  
  {name:"Orly 94310"},
  
   
  
  {name:"Thiais 94320"},
  
   
  
  {name:"Joinville-le-Pont 94340"},
  
   
  
  {name:"Villiers-sur-Marne 94350"},
  
   
  
  {name:"Bry-sur-Marne 94360"},
  
   
  
  {name:"Sucy-en-Brie 94370"},
  
   
  
  {name:"Bonneuil-sur-Marne 94380 "},
  
  {name:"Vitry-sur-Seine 94400"},

  
  {name:"Saint-Maurice 94410 "},
  
  
  {name:"Le Plessis-Trévise 94420"},
  
   
  
  {name:"Chennevières-sur-Marne 94430"},
  
   
  
  {name:"Marolles-en-Brie 94440"},
   {name:"Santeny 94440"},
   {name:"Villecresnes 94440"},
  
   
  
  {name:"Limeil-Brévannes 94450"},
  
   
  
  {name:"Valenton 94460"},
  
   
  
  {name:"Boissy-Saint-Léger 94470"},
  
   
  
  {name:"Ablon-sur-Seine 94480"},
  
   
  
  {name:'Ormesson-sur-Marne 94490'},
  
   
  
  {name:"Champigny-sur-Marne 94500"},
  
   
  
  {name:"La Queue-en-Brie 94510"},
  
   
  
  {name:"Mandres-les-Roses 94520"},
   {name:"Périgny 94520"},
  
   
  
  {name:"Chevilly-Larue 94550"},
  
   
  
  {name:"Choisy-le-Roi 94600"},
  
   
  
  {name:"Maisons-Alfort 94700"},
  
   
  
  {name:"Villejuif 94800"},
  
   
  
  {name:"Noiseau 94880"},
  
   
  
  {name:"Boisemont 95000"},
   {name:"Cergy 95000"},
   {name:"Neuville-sur-Oise 95000"},
   {name:"Pontoise 95000"},
  
   
  
  {name:"Argenteuil 95100"},
  
   
  
  {name:"Sannois 95110"},
  
   
  
  {name:"Ermont 95120"},
  
   
  
  {name:"Franconville 95130"},
   {name:"Le Plessis-Bouchard 95130"},
  
   
  
  {name:"Garges-lès-Gonesse 95140"},
  
   
  
  {name:"Taverny 95150"},
  
   
  
  {name:"Montmorency 95160"},
  
   
  
  {name:"Deuil-la-Barre 95170"},
  
   
  
  {name:"Menucourt 95180"},
  
   
  
  {name:"Châtenay-en-France 95190"},
   {name:"Fontenay-en-Parisis 95190"},
   {name:"Goussainville 95190"},
  
   
  
  {name:"Sarcelles 95200"},
  
   
  
  {name:"Saint-Gratien 95210"},
  
   
  
  {name:"Herblay 95220"},
  
   
  
  {name:"Soisy-sous-Montmorency 95230"},
  
   
  
  {name:"Cormeilles-en-Parisis 95240"},
  
   
  
  {name:"Beauchamp 95250"},
  
   
  
  {name:"Beaumont-sur-Oise 95260"},
   {name:"Mours 95260"},
  
   
  
  {name:"Asnières-sur-Oise 95270"},
   {name:"Bellefontaine 95270"},
   {name:"Belloy-en-France 95270"},
   {name:"Chaumontel 95270"},
   {name:"Épinay-Champlâtreux 95270"},
   {name:"Lassy 95270"},
   {name:"Luzarches 95270"},
   {name:"Noisy-sur-Oise 95270"},
   {name:"Le Plessis-Luzarches 95270"},
   {name:"Saint-Martin-du-Tertre 95270"},
   {name:"Seugy 95270"},
   {name:"Viarmes 95270"},
  
   
  
  {name:"Jouy-le-Moutier 95280"},
  {name:"L' Isle-Adam 95290"},  
  {name:'Ennery Hérouville Livilliers 95300 '},  
  {name:"Saint-Ouen-l'Aumône 95310 "},
  
  {name:'Saint-Leu-la-Forêt 95320 '},
  
  {name:'Domont 95330 '},
  
   
  
  {name:'Bernes-sur-Oise 95340 '},
  {name:'Persan 95340 '},
  {name:' Ronquerolles 95340 '},
  
  {name:'Piscop 95350 '},
  {name:'Saint-Brice-sous-Forêt 95350 '},
  
  {name:'Montmagny 95360 '},
  
  {name :'Montigny-lès-Cormeilles 95370 '},
  
  {name:'Chennevières-lès-Louvres 95380 '},
  {name:'Épiais-lès-Louvres 95380 '},
  {name:'Puiseux-en-France 95380 '},
  {name:'Villeron 95380 '},
  
  {name:'Saint-Prix 95390 '},
  
  {name :'Arnouville 95400 '},
  {name :'Villiers-le-Bel 95400 '},
  
  {name:'Groslay 95410  '},
  
  {name: 'Arthies 95420 '},
  {name: 'Banthelu 95420 '},
  {name: 'La Chapelle-en-Vexin 95420 '},
  {name: 'Charmont 95420 '},
  {name: 'Cléry-en-Vexin 95420 '},
  {name: 'Genainville 95420 '},
  {name: 'Hodent 95420 '},
  {name: 'Magny-en-Vexin 95420 '},
  {name: 'Maudétour-en-Vexin 95420 '},
  {name: 'Nucourt Omerville 95420 '},
  {name: 'Saint-Gervais 95420 '},
  {name: ' Wy-dit-Joli-Village 95420 '},
  
  {name:'Auvers-sur-Oise Butry-sur-Oise 95430' },
  
  {name:'Écouen 95440 '},
  
  
  {name:'Ableiges 95450 '},
  {name:'Avernes 95450 '},
  {name:'Commeny 95450 '},
  {name:'Condécourt 95450 '},
  {name:'Frémainville 95450 '},
  {name:'Gadancourt 95450 '},
  {name:'Gouzangrez 95450 '},
  {name:'Guiry-en-Vexin 95450 '},
  {name:'Longuesse 95450 '},
  {name:'Le Perchay Sagy 95450 '},
  {name:'Seraincourt 95450 '},
  {name:' Théméricourt Us Vigny 95450 '},
  
  {name: 'Ézanville 95460  '},
  
  {name:'Fosses 95470 '},
  {name:'Saint-Witz Survilliers  95470 '},
  {name:'Vémars 95470 '},
  
  {name: 'Pierrelaye 95480' },
  
  
  
  {name: 'Vauréal 95490 '},
  
  
  {name:'Bonneuil-en-France 95500 '},
  {name:'Gonesse 95500 '},
  {name:'Le Thillay Vaudherland 95500 '},
  
  {name:'Aincourt 95510 '},
  {name:'Amenucourt 95510 '},
  {name:'Chérence 95510 '},
  {name:'Saint-Cyr-en-Arthies 95510 '},
  {name:'Vétheuil 95510 '},
  {name:'Vienne-en-Arthies 95510 '},
  {name:'Villers-en-Arthies 95510 '},
  
  
  
{name:'Osny 95520 '},
   
  
  {name: 'La Frette-sur-Seine 95530 '},
  
  {name:'Méry-sur-Oise 95540 '},
  
  {name: 'Bessancourt 95550 '},
  
{name:'Baillet-en-France'},
{name:"Chauvry Maffliers 95560"},
 {name:'Montsoult 95560 '},

  
  {name:'Attainville 95570'},
  {name:"Bouffémont 95570"},
  {name:"Moisselles 95570"},
  {name:'Villaines-sous-Bois 95570 '},
  
  
  
  {name:'Andilly Margency 95580 '},
  
  {name:'Nerville-la-Forêt 95590'}, 
  {name:'Nointel Presles 95590 '},
  
  {name: 'Eaubonne 95600 '},
  
  {name:'Éragny 95610 '},
  
  {name: 'Parmain 95620 '},
  
  {name:'Mériel 95630' },
  
  
  
{name:'Bréançon 95640'},
{name:"Brignancourt 95640"},
{name:"Haravilliers 95640"},
{name:"Le Heaulme 95640"},
{name:"Marines 95640"},
{name:"Moussy 95640"},
{name:"Neuilly-en-Vexin 95640"},
{name:'Santeuil  95640 '},
  
  {name:"Boissy-l'Aillerie 95650"},
  {name:"Courcelles-sur-Viosne 95650"},
  {name:"Génicourt 95650"},
  {name:"Montgeroult 95650"},
  {name:"Puiseux-Pontoise 95650 "},
  
  {name: 'Champagne-sur-Oise 95660 '},
  
  
  
  {name: 'Marly-la-Ville 95670 '},
  
  
  
 {name:'Montlignon 95680 '},
  
   
  
{name: 'Frouville 95690'},
{name:"Hédouville 95690"},
{name:"Labbeville 95690"},
{name:'Nesles-la-Vallée 95690 '},
  

  
{name: 'Roissy-en-France  95700 '},
  

  
  {name: 'Ambleville 95710'},
  {name:'Bray-et-Lû Chaussy 95710 '},
  
  
  
  {name: 'Bouqueval 95720'},
  {name:"Le Mesnil-Aubry 95720"},
  {name:"Le Plessis-Gassot 95720 "},
  {name:'Villiers-le-Sec 95720 '},
  
  {name:'Frépillon 95740 '},
  
  {name: 'Le Bellay-en-Vexin Chars 95750 '},
  
  {name:'Valmondois 95760 '},
  
  {name : 'Buhy Montreuil-sur-Epte Saint-Clair-sur-Epte 95770 '},
  
  {name: 'Haute-Isle La Roche-Guyon 95780 '},
  
  {namne:'Courdimanche 95800 '},
  
  {name: 'Arronville 95810'},
  {name:"Berville 95810"},
  {name:"Épiais-Rhus 95810"},
  {name:"Grisy-les-Plâtres 95810"},
  {name:"Menouville 95810 "},
  {name:"Theuville 95810"},
  {name:'Vallangoujard 95810 '},  
  {name: 'Bruyères-sur-Oise 95820 '},
  
  {name:' Cormeilles-en-Vexin 95830 '},
  {name:'Frémécourt 95830'},
  
  
  {name: ' Béthemont-la-Forêt '},
  {name:'Villiers-Adam 95840'},
  
  
  {name:'Jagny-sous-Bois 95850'},
  {name:'Mareil-en-France 95850 '},
  
  {name: 'Bezons 95870'},
 
  {name:'Enghien-les-Bains 95880'}
  
  ]
  constructor() { }
}
